webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = relativeTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = shortDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["k"] = isValidClient;
/* harmony export (immutable) */ __webpack_exports__["j"] = isValidRedirectURI;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationTools; });
/* unused harmony export Sport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Sports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TournamentTools; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NA_VENUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MatchTools; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DialogInputTypes; });
/* unused harmony export DialogInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(53);






function relativeTime(date) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).fromNow();
}

function shortDate(date) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format("ll");
}

/**
 * Shorten the text to desired length, adding ellipses if necessary
 * @param {input text} text
 * @param {max # of chars to show} maxChars
 */
function truncate(text, maxChars) {
  if (text && text.length > maxChars && maxChars > 0) return text.slice(0, maxChars) + "…";
  return text;
}

// TODO: Move this to config
var CLIENT_ID = "GOOGLE";
var PROJECT_ID = "quickTourney";

function isValidClient(clientId) {
  return clientId === CLIENT_ID;
}
function isValidRedirectURI(url) {
  return url && url.match("https://oauth-redirect.googleusercontent.com/r/" + PROJECT_ID);
}

//#region Location
var LocationTools = function () {
  function LocationTools() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LocationTools);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LocationTools, null, [{
    key: "isMine",
    value: function isMine(location) {
      if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.currentUser) return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.currentUser.user.id === location.userId;
      return false;
    }
  }]);

  return LocationTools;
}();
//#endregion

//#region Tournament
var Sport = function Sport(name, icon) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Sport);

  this.name = name;
  this.icon = icon;
};

var Sports = [new Sport("Badminton", "/static/img/sports/icons8-shuttercock-50.png"), new Sport("Tennis", "/static/img/sports/icons8-tennis-player-50.png"), new Sport("Table Tennis", "/static/img/sports/icons8-ping-pong-50.png"), new Sport("Volleyball", "/static/img/sports/icons8-volleyball-player-50.png"), new Sport("Other", "")];

var TournamentTools = function () {
  function TournamentTools() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TournamentTools);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TournamentTools, null, [{
    key: "isMine",
    value: function isMine(tournament) {
      if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.currentUser) return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.currentUser.user.id === tournament.userId;
      return false;
    }
  }, {
    key: "icon",
    value: function icon(tournament) {
      var sport = Sports.find(function (x) {
        return x.name === tournament.sport;
      });
      return sport && sport.icon;
    }
  }]);

  return TournamentTools;
}();
//#endregion

//#region Matches
var BYE_NAME = "BYE";
var NA_VENUE = "N/A";

var MatchTools = function () {
  function MatchTools() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MatchTools);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MatchTools, null, [{
    key: "isReady",

    /**
     * A match is deemed ready if both competitors are set, it hasn't started or ended and neither competitor is currently
     * in a match that is in-progress.
     *
     * @static
     * @param {*} match
     * @returns
     * @memberof MatchTools
     */
    value: function isReady(tournament, match) {
      if (match.status === __WEBPACK_IMPORTED_MODULE_3__models__["a" /* MatchStatus */].Ready) {
        return !MatchTools.isPlaying(tournament, match.firstCompetitor, match.secondCompetitor);
      }
      return false;
    }
  }, {
    key: "isInProgress",
    value: function isInProgress(match) {
      return match.status === __WEBPACK_IMPORTED_MODULE_3__models__["a" /* MatchStatus */].InProgress;
    }
  }, {
    key: "isCompleted",
    value: function isCompleted(match) {
      return match.status === __WEBPACK_IMPORTED_MODULE_3__models__["a" /* MatchStatus */].Completed;
    }
  }, {
    key: "isPending",
    value: function isPending(tournament, match) {
      if (match.status === __WEBPACK_IMPORTED_MODULE_3__models__["a" /* MatchStatus */].Ready) {
        return MatchTools.isPlaying(tournament, match.firstCompetitor, match.secondCompetitor);
      }
      return match.status === __WEBPACK_IMPORTED_MODULE_3__models__["a" /* MatchStatus */].NotReady;
    }
  }, {
    key: "isPlaying",
    value: function isPlaying(tournament) {
      for (var _len = arguments.length, competitors = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        competitors[_key - 1] = arguments[_key];
      }

      return tournament.matches.some(function (x) {
        return x.status === __WEBPACK_IMPORTED_MODULE_3__models__["a" /* MatchStatus */].InProgress && (x.firstCompetitor && competitors.some(function (y) {
          return y.id === x.firstCompetitor.id;
        }) || x.secondCompetitor && competitors.some(function (y) {
          return y.id === x.secondCompetitor.id;
        }));
      });
    }
  }, {
    key: "competitorsDescription",
    value: function competitorsDescription(match) {
      if (MatchTools.isCompleted(match)) {
        if (match.loser.name === BYE_NAME) return match.winner.name + " had a bye";
        return MatchTools.competitorName(match.winner) + " def " + MatchTools.competitorName(match.loser);
      }
      return MatchTools.competitorName(match.firstCompetitor) + " vs " + MatchTools.competitorName(match.secondCompetitor);
    }
  }, {
    key: "competitorName",
    value: function competitorName(competitor) {
      return competitor && competitor.name || "________";
    }
  }, {
    key: "extraInfo",
    value: function extraInfo(tournament, match) {
      var extraInfo = [];
      if (MatchTools.isCompleted(match)) {
        extraInfo.push("" + (match.score.notes || "No score"));
        extraInfo.push("Ended " + relativeTime(match.endTime));
      } else if (MatchTools.isInProgress(match)) extraInfo.push("Started " + relativeTime(match.startTime));else if (MatchTools.isReady(tournament, match)) extraInfo.push("Ready to start");else extraInfo.push("Not ready");
      if (match.venue) extraInfo.push(match.venue.name);
      return extraInfo.join(", ");
    }
  }, {
    key: "icon",
    value: function icon(tournament, match) {
      return MatchTools.isCompleted(match) ? "star" : MatchTools.isInProgress(match) ? "star_half" : MatchTools.isReady(tournament, match) ? "star_border" : "pan_tool";
    }
  }, {
    key: "venueOptions",
    value: function venueOptions(tournament) {
      var result = [{ value: NA_VENUE, display: NA_VENUE }];
      var v = tournament.venuesToUse;
      if (v) {
        return result.concat(v.filter(function (x) {
          return x.isActive && !x.reservedBy;
        }).sort(function (a, b) {
          return a.name < b.name ? -1 : b.name < a.name ? 1 : 0;
        }).map(function (x) {
          return { value: x.id, display: x.name };
        }));
      }
      return result;
    }
  }, {
    key: "competitorOptions",
    value: function competitorOptions(tournament) {
      return tournament.competitors.map(function (x) {
        return { value: x.id, display: x.name };
      });
    }
  }]);

  return MatchTools;
}();
//#endregion

//#region Competitor
/*
export class CompetitorTools {
  static isReady(comp) {
  }
}
*/
//#endregion

//#region Dialogs
var DialogInputTypes = {
  text: "text",
  number: "number",
  bool: "checkbox",
  email: "email",
  pw: "password",
  date: "date",
  datetime: "datetime-local"
};

var DialogInput = function DialogInput() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DialogInput);

  this.label = "";
  this.hint = "";
  this.value = "";
  this.type = DialogInputTypes.text;
  this.options = [];
  this.required = false;
  this.multiline = false;
  this.disabled = false;
};
//#endregion

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tournamentScoreFragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return tournamentCompetitorFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tournamentMatchFragment; });
/* unused harmony export tournamentLocationFragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tournamentVenueFragment; });
/* unused harmony export tournamentFlightFragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tournamentMainFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tournamentMatchStartedFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tournamentMatchEndedFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tournamentQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentScore on Score {\n    totalWinnerScore\n    totalLoserScore\n    notes\n  }\n"], ["\n  fragment TournamentScore on Score {\n    totalWinnerScore\n    totalLoserScore\n    notes\n  }\n"]),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentCompetitor on Competitor {\n    id\n    name\n    isActive\n    rank\n    isReadyToCompete\n    amountPaid\n    points\n    isEliminated\n    resultSequence\n    isBye\n  }\n"], ["\n  fragment TournamentCompetitor on Competitor {\n    id\n    name\n    isActive\n    rank\n    isReadyToCompete\n    amountPaid\n    points\n    isEliminated\n    resultSequence\n    isBye\n  }\n"]),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentMatch on Match {\n    id\n    name\n    description\n    comments\n    isActive\n    startTime\n    endTime\n    status\n    flightId\n    roundId\n    winnerDestinationMatchId\n    loserDestinationMatchId\n    score {\n      ...TournamentScore\n    }\n    venue {\n      id\n      name\n    }\n    firstCompetitor {\n      id\n      name\n      rank\n    }\n    secondCompetitor {\n      id\n      name\n      rank\n    }\n    winner {\n      id\n      name\n      rank\n    }\n    loser {\n      id\n      name\n      rank\n    }\n  }\n  ", "\n"], ["\n  fragment TournamentMatch on Match {\n    id\n    name\n    description\n    comments\n    isActive\n    startTime\n    endTime\n    status\n    flightId\n    roundId\n    winnerDestinationMatchId\n    loserDestinationMatchId\n    score {\n      ...TournamentScore\n    }\n    venue {\n      id\n      name\n    }\n    firstCompetitor {\n      id\n      name\n      rank\n    }\n    secondCompetitor {\n      id\n      name\n      rank\n    }\n    winner {\n      id\n      name\n      rank\n    }\n    loser {\n      id\n      name\n      rank\n    }\n  }\n  ", "\n"]),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentLocation on Location {\n    id\n    name\n    venues {\n      ...TournamentVenue\n    }\n  }\n"], ["\n  fragment TournamentLocation on Location {\n    id\n    name\n    venues {\n      ...TournamentVenue\n    }\n  }\n"]),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentVenue on Venue {\n    id\n    name\n    isActive\n    reservedBy\n  }\n"], ["\n  fragment TournamentVenue on Venue {\n    id\n    name\n    isActive\n    reservedBy\n  }\n"]),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentFlight on Flight {\n    id\n    name\n    description\n    comments\n    rounds {\n      id\n      name\n      description\n      comments\n    }\n    standings {\n      id\n      name\n      resultSequence\n      points\n    }\n  }\n"], ["\n  fragment TournamentFlight on Flight {\n    id\n    name\n    description\n    comments\n    rounds {\n      id\n      name\n      description\n      comments\n    }\n    standings {\n      id\n      name\n      resultSequence\n      points\n    }\n  }\n"]),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentMain on Tournament {\n    id\n    userId\n    name\n    description\n    comments\n    regulations\n    isActive\n    isPublic\n    sport\n    circuit\n    startDate\n    endDate\n    format\n  }\n"], ["\n  fragment TournamentMain on Tournament {\n    id\n    userId\n    name\n    description\n    comments\n    regulations\n    isActive\n    isPublic\n    sport\n    circuit\n    startDate\n    endDate\n    format\n  }\n"]),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentMatchStarted on Tournament {\n    id\n    venuesToUse {\n      ...TournamentVenue\n    }\n    matches {\n      ...TournamentMatch\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment TournamentMatchStarted on Tournament {\n    id\n    venuesToUse {\n      ...TournamentVenue\n    }\n    matches {\n      ...TournamentMatch\n    }\n  }\n  ", "\n  ", "\n"]),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment TournamentMatchEnded on Tournament {\n    ...TournamentMatchStarted\n    competitors {\n      ...TournamentCompetitor\n    }\n    flights {\n      ...TournamentFlight\n    }\n  }\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment TournamentMatchEnded on Tournament {\n    ...TournamentMatchStarted\n    competitors {\n      ...TournamentCompetitor\n    }\n    flights {\n      ...TournamentFlight\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  query tournament($id: ID!) {\n    tournament(id: $id) {\n      ...TournamentMain\n      location {\n        ...TournamentLocation\n      }\n      venuesToUse {\n        ...TournamentVenue\n      }\n      competitors {\n        ...TournamentCompetitor\n      }\n      flights {\n        ...TournamentFlight\n      }\n      matches {\n        ...TournamentMatch\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  query tournament($id: ID!) {\n    tournament(id: $id) {\n      ...TournamentMain\n      location {\n        ...TournamentLocation\n      }\n      venuesToUse {\n        ...TournamentVenue\n      }\n      competitors {\n        ...TournamentCompetitor\n      }\n      flights {\n        ...TournamentFlight\n      }\n      matches {\n        ...TournamentMatch\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);



var tournamentScoreFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);

var tournamentCompetitorFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2);

var tournamentMatchFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject3, tournamentScoreFragment);
var tournamentLocationFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject4);

var tournamentVenueFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject5);

var tournamentFlightFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject6);

var tournamentMainFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject7);

var tournamentMatchStartedFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject8, tournamentVenueFragment, tournamentMatchFragment);

var tournamentMatchEndedFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject9, tournamentMatchStartedFragment, tournamentCompetitorFragment, tournamentFlightFragment);

var tournamentQuery = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject10, tournamentMainFragment, tournamentCompetitorFragment, tournamentMatchFragment, tournamentLocationFragment, tournamentVenueFragment, tournamentFlightFragment);

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(449),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return locationVenueFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationMainFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment LocationVenue on Venue {\n    id\n    name\n    description\n    comments\n    reservedBy\n  }\n"], ["\n  fragment LocationVenue on Venue {\n    id\n    name\n    description\n    comments\n    reservedBy\n  }\n"]),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  fragment LocationMain on Location {\n    id\n    userId\n    name\n    description\n    comments\n    isActive\n    address\n  }\n"], ["\n  fragment LocationMain on Location {\n    id\n    userId\n    name\n    description\n    comments\n    isActive\n    address\n  }\n"]),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  query location($id: ID!) {\n    location(id: $id) {\n      ...LocationMain\n      venues {\n        ...LocationVenue\n      }\n    }\n  }\n  ", "\n  ", "\n"], ["\n  query location($id: ID!) {\n    location(id: $id) {\n      ...LocationMain\n      venues {\n        ...LocationVenue\n      }\n    }\n  }\n  ", "\n  ", "\n"]);



var locationVenueFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);

var locationMainFragment = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2);

var locationQuery = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject3, locationMainFragment, locationVenueFragment);

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(450),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f833e94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations_commonMutations__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_commonActions__ = __webpack_require__(255);








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist__["a" /* default */]({
  key: "vuex",
  storage: localStorage
  //reducer: state => ({ currentUser: state.currentUser })
});

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__mutations_commonMutations__["a" /* default */]);
var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__actions_commonActions__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  plugins: [vuexLocalStorage.plugin],
  state: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */],
  actions: actions,
  mutations: mutations,
  getters: {
    currentTournamentId: function currentTournamentId(state) {
      var recent = state.recentTournaments;
      if (recent && recent.length > 0) return recent[recent.length - 1].id;
      return undefined;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MatchStatus; });
var MatchStatus = {
  NotReady: "NOTREADY",
  Ready: "READY",
  InProgress: "INPROGRESS",
  Completed: "COMPLETED",
  Unknown: "UNKNOWN"
};

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(452),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68757b18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(439),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-268de8c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-815d5406",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Redirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleAssistantLinkAccount__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleAssistantLinkAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GoogleAssistantLinkAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Home_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PublicTournaments__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PublicTournaments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PublicTournaments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MyTournaments__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MyTournaments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MyTournaments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MyLocations__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MyLocations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_MyLocations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tournament__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tournament___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Tournament__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Location__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_About__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Help__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ContactInfo__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ContactInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ContactInfo__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/googleassistantlinkaccount",
    name: "GoogleAssistantLinkAccount",
    component: __WEBPACK_IMPORTED_MODULE_3__GoogleAssistantLinkAccount___default.a
  }, { path: "/redirect", name: "Redirect", component: __WEBPACK_IMPORTED_MODULE_2__Redirect___default.a }, {
    path: "/",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_4__Home_vue___default.a,
    props: true,
    children: [{ path: "publicTournaments", components: { body: __WEBPACK_IMPORTED_MODULE_5__components_PublicTournaments___default.a } }, { path: "myTournaments", components: { body: __WEBPACK_IMPORTED_MODULE_6__components_MyTournaments___default.a } }, { path: "myLocations", components: { body: __WEBPACK_IMPORTED_MODULE_7__components_MyLocations___default.a } }, { path: "tournament", components: { body: __WEBPACK_IMPORTED_MODULE_8__components_Tournament___default.a } }, { path: "location", components: { body: __WEBPACK_IMPORTED_MODULE_9__components_Location___default.a } }, { path: "about", components: { body: __WEBPACK_IMPORTED_MODULE_10__components_About___default.a } }, { path: "contact", components: { body: __WEBPACK_IMPORTED_MODULE_12__components_ContactInfo___default.a } }, { path: "help", components: { body: __WEBPACK_IMPORTED_MODULE_11__components_Help___default.a } }]
  }]
}));

/***/ }),
/* 221 */,
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */,
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(460),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apollo_client__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apollo_link_http__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apollo_link_context__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apollo_cache_inmemory__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_apollo__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_material_dist_vue_material_min_css__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material_dist_theme_default_dark_css__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material_dist_theme_default_dark_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_material_dist_theme_default_dark_css__);














__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_apollo__["a" /* default */]);

var httpLink = new __WEBPACK_IMPORTED_MODULE_7_apollo_link_http__["a" /* HttpLink */]({
  uri: "https://us-central1-quicktourney-785b5.cloudfunctions.net/api/graphql"
});

var authLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_apollo_link_context__["a" /* setContext */])(function (_, _ref) {
  var headers = _ref.headers;

  // get the authentication token from local storage if it exists
  //const cu = localStorage.getItem(CURRENT_USER_KEY)
  var cu = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.currentUser;
  // return the headers to the context so httpLink can read them
  return {
    headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headers, {
      Authorization: cu && cu.token ? "Bearer " + cu.token : ""
    })
  };
});

// Create the apollo client
var apolloClient = new __WEBPACK_IMPORTED_MODULE_6_apollo_client__["a" /* ApolloClient */]({
  link: authLink.concat(httpLink),
  cache: new __WEBPACK_IMPORTED_MODULE_9_apollo_cache_inmemory__["a" /* InMemoryCache */](),
  connectToDevTools: true
});

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_10_vue_apollo__["a" /* default */]({
  defaultClient: apolloClient
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  apolloProvider: apolloProvider,
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var MAX_RECENT_TOURNAMENTS = 5;

/* harmony default export */ __webpack_exports__["a"] = ({
  setCurrentUser: function setCurrentUser(state, value) {
    state.currentUser = value;
    if (value) {
      //Vue.material.setCurrentTheme(value.role)
    }
  },

  setNotification: function setNotification(state, value) {
    state.notification = value;
  },

  toggleMenuVisibility: function toggleMenuVisibility(state) {
    state.menuVisible = !state.menuVisible;
  },

  pushToRecentTournamentId: function pushToRecentTournamentId(state, value) {
    if (value) {
      if (!state.recentTournaments) state.recentTournaments = [];
      var existingIndex = state.recentTournaments.findIndex(function (x) {
        return x.id === value.id;
      });
      if (existingIndex >= 0) state.recentTournaments.splice(existingIndex, 1);
      state.recentTournaments.push(value);
      if (state.recentTournaments.length > MAX_RECENT_TOURNAMENTS) state.recentTournaments.shift();
    }
  },

  setCurrentLocationId: function setCurrentLocationId(state, value) {
    state.currentLocationId = value;
  },

  setShowThisMonth: function setShowThisMonth(state, value) {
    state.showThisMonth = value;
  },
  setShowNextMonth: function setShowNextMonth(state, value) {
    state.showNextMonth = value;
  },
  setShowFuture: function setShowFuture(state, value) {
    state.showFuture = value;
  },
  setShowOlder: function setShowOlder(state, value) {
    state.showOlder = value;
  },

  setShowCompleted: function setShowCompleted(state, value) {
    state.showCompleted = value;
  },
  setShowInProgress: function setShowInProgress(state, value) {
    state.showInProgress = value;
  },
  setShowReady: function setShowReady(state, value) {
    state.showReady = value;
  },
  setShowPending: function setShowPending(state, value) {
    state.showPending = value;
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  menuVisible: false,
  notification: "",
  currentUser: null,
  currentLocationId: null,
  recentTournaments: [],

  // tournament listing options
  showThisMonth: true,
  showNextMonth: true,
  showFuture: true,
  showOlder: false,

  // match listing options
  showCompleted: false,
  showInProgress: true,
  showReady: true,
  showPending: true
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app"
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_helper__ = __webpack_require__(2);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GoogleAssistantLinkAccount",
  created: function created() {
    console.log("LINK ACCOUNT PARAMS", this.$route.query);
    var clientId = this.$route.query.client_id;
    var redirectURI = this.$route.query.redirect_uri;
    console.log(clientId, redirectURI);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__js_helper__["k" /* isValidClient */])(clientId) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__js_helper__["j" /* isValidRedirectURI */])(redirectURI)) {
      console.log("here2");
      this.$cookie.set("link_account_redirect_uri", redirectURI);
      this.$cookie.set("link_account_state", this.$route.query.state);
      this.$cookie.set("link_account_response_type", this.$route.query.response_type);
      window.location.href = ""; // TODO
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_loginDialog_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_loginDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_loginDialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Home",
  components: {
    MainMenu: __WEBPACK_IMPORTED_MODULE_0__components_MainMenu_vue___default.a,
    LoginDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_loginDialog_vue___default.a
  },

  data: function data() {
    return { showLoginDialog: false, showNotification: false };
  },

  computed: {
    currentUser: {
      get: function get() {
        return this.$store.state.currentUser;
      }
    },

    /*
    theme: {
      get() {
        return this.currentUser ? "loggedIn" : "default";
      }
    },
    */

    menuVisible: {
      get: function get() {
        return this.$store.state.menuVisible;
      },
      set: function set(value) {
        this.toggleMenu();
      }
    },

    notification: {
      get: function get() {
        return this.$store.state.notification;
      },
      set: function set(value) {
        this.$store.commit("setNotification", value);
      }
    }
  },

  watch: {
    notification: function notification(value) {
      this.showNotification = true;
    }
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.$store.commit("toggleMenuVisibility");
    },
    logOut: function logOut() {
      this.$store.commit("setCurrentUser", undefined);
      this.$router.push({ path: "/publicTournaments" });
      this.notification = "You are now logged out";
    }
  },
  created: function created() {
    this.$router.push({ path: "/publicTournaments" });
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_helper__ = __webpack_require__(2);
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Redirect",
  created: function created() {
    var accessToken = this.$route.query.access_token;
    console.log(this.$route.query);
    console.log("hello", accessToken);
    if (accessToken) {
      accessToken = accessToken.split(":")[1].split(".")[0];
      // Check if the redirect is due to an account-linking request:
      var redirectURI = this.$cookie.get("link_account_redirect_uri");
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__js_helper__["j" /* isValidRedirectURI */])(redirectURI)) {
        console.log("Completing account linking");
        // invalidate the redirect_uri cookie (note there is a possible race condition by using cookies to determine how to handle the oath redirect)
        this.$cookie.delete("link_account_redirect_uri");
        var state = this.$cookie.get("link_account_state");
        window.location.href = redirectURI + "#access_token=" + accessToken + "&token_type=bearer&state=" + state;
      }
      // Otherwise route to the UI home
      else this.$router.push({ name: "Home", params: { accessToken: accessToken } });
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Info_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Info_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "About",
  components: { Info: __WEBPACK_IMPORTED_MODULE_0__components_Info_vue___default.a }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Info_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Info_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ContactInfo",
  components: { Info: __WEBPACK_IMPORTED_MODULE_0__components_Info_vue___default.a }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Info_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Info_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Help",
  components: { Info: __WEBPACK_IMPORTED_MODULE_0__components_Info_vue___default.a }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Info",
  props: { title: String }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_location__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_editField_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_editField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_editField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_addVenueDialog_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_addVenueDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_addVenueDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_upsertLocationDialog_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dialogs_upsertLocationDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_dialogs_upsertLocationDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($locationId: ID!, $venueId: ID!) {\n              deleteVenue(locationId: $locationId, venueId: $venueId)\n            }\n          "], ["\n            mutation($locationId: ID!, $venueId: ID!) {\n              deleteVenue(locationId: $locationId, venueId: $venueId)\n            }\n          "]),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($locationId: ID!) {\n              deleteLocation(locationId: $locationId)\n            }\n          "], ["\n            mutation($locationId: ID!) {\n              deleteLocation(locationId: $locationId)\n            }\n          "]);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Location",
  components: { EditField: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_editField_vue___default.a, AddVenueDialog: __WEBPACK_IMPORTED_MODULE_5__components_dialogs_addVenueDialog_vue___default.a, UpsertLocationDialog: __WEBPACK_IMPORTED_MODULE_6__components_dialogs_upsertLocationDialog_vue___default.a },
  apollo: {
    location: function location() {
      // this query has to be a function to be called after the component is created, giving access to the other properties
      return {
        query: __WEBPACK_IMPORTED_MODULE_3__graphql_location__["a" /* locationQuery */],
        variables: function variables() {
          return {
            id: this.locationId
          };
        }
      };
    }
  },

  data: function data() {
    return {
      showEditLocationDialog: false,
      showVenueDialog: false,
      showConfirmDelete: false,
      name: {
        label: "Location Name",
        required: true
      },
      address: {
        label: "Address"
      },
      description: {
        label: "A Short description"
      },
      comments: {
        label: "Comments",
        multiline: true
      }
    };
  },

  computed: {
    inputs: {
      get: function get() {
        return [this.name, this.address, this.description, this.comments];
      }
    },
    currentUser: {
      get: function get() {
        return this.$store.state.currentUser;
      }
    },
    locationId: {
      get: function get() {
        return this.$store.state.currentLocationId;
      }
    }
  },

  methods: {
    isMine: __WEBPACK_IMPORTED_MODULE_2__js_helper__["a" /* LocationTools */].isMine,
    newVenue: function newVenue() {
      this.showVenueDialog = true;
    },
    deleteVenue: function deleteVenue(id) {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
        variables: {
          locationId: this.location.id,
          venueId: id
        }
      }).then(function (result) {
        _this.$root.$emit("updateLocation", _this.location.id);
        _this.$store.commit("setNotification", "Venue deleted");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to delete venue");
      });
    },
    refetch: function refetch() {
      if (this.$apollo.queries.location) this.$apollo.queries.location.refetch();
    },
    deleteLocation: function deleteLocation() {
      var _this2 = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2),
        variables: {
          locationId: this.location.id
        }
      }).then(function (result) {
        _this2.$store.commit("setNotification", "Location has been deleted");
        _this2.$router.push({ path: "/myLocations" });
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to delete location");
      });
    }
  },

  created: function created() {
    var _this3 = this;

    // This is a temporary way of updating the location data (refetching on local change).
    // Ideally we subscribe to location-update events and refetch then, but firebase cloud functions
    // doesn't support web sockets for graphql subscriptions.
    // An alternative is to move the api off Firebase.
    // Another alternative is to do the subscription through Firebase events.
    this.$root.$on("updateLocation", function (id) {
      if (id === _this3.locationId) _this3.refetch();
    });
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dialogs_upsertTournamentDialog_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dialogs_upsertTournamentDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_dialogs_upsertTournamentDialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MainMenu",
  components: { UpsertTournamentDialog: __WEBPACK_IMPORTED_MODULE_0__components_dialogs_upsertTournamentDialog_vue___default.a },
  data: function data() {
    return {
      showCreateTournamentDialog: false
    };
  },

  computed: {
    currentUser: {
      get: function get() {
        return this.$store.state.currentUser;
      }
    },
    favourites: {
      get: function get() {
        return this.$store.state.recentTournaments;
      }
    }
  },

  methods: {
    close: function close() {
      this.$store.commit("toggleMenuVisibility");
    },
    selectTournament: function selectTournament(item) {
      this.$store.commit("pushToRecentTournamentId", item);
      this.close();
    },
    setCurrentView: function setCurrentView(viewName) {
      this.$router.push({ path: viewName });
      this.close();
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listingComponents_locations_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listingComponents_locations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_listingComponents_locations_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n          query {\n            locations {\n              id\n              name\n              description\n              address\n            }\n          }\n        "], ["\n          query {\n            locations {\n              id\n              name\n              description\n              address\n            }\n          }\n        "]);

//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MyLocations",
  components: { Locations: __WEBPACK_IMPORTED_MODULE_2__components_listingComponents_locations_vue___default.a },

  apollo: {
    locations: function locations() {
      return {
        query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject)
      };
    }
  },

  methods: {
    refetch: function refetch() {
      if (this.$apollo.queries.locations) this.$apollo.queries.locations.refetch();
    }
  },

  created: function created() {
    var _this = this;

    // This is a temporary way of updating the location data (refetching on local change).
    // Ideally we subscribe to location-update events and refetch then, but firebase cloud functions
    // doesn't support web sockets for graphql subscriptions.
    // An alternative is to move the api off Firebase.
    // Another alternative is to do the subscription through Firebase events.
    this.$root.$on("updateLocation", function (id) {
      _this.refetch();
    });
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listingComponents_tournaments_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listingComponents_tournaments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_listingComponents_tournaments_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n          query {\n            myTournaments {\n              id\n              name\n              description\n              comments\n              sport\n              circuit\n              startDate\n              endDate\n              format\n              location {\n                id\n                name\n              }\n            }\n          }\n        "], ["\n          query {\n            myTournaments {\n              id\n              name\n              description\n              comments\n              sport\n              circuit\n              startDate\n              endDate\n              format\n              location {\n                id\n                name\n              }\n            }\n          }\n        "]);

//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MyTournaments",
  components: { Tournaments: __WEBPACK_IMPORTED_MODULE_2__components_listingComponents_tournaments_vue___default.a },

  apollo: {
    myTournaments: function myTournaments() {
      return {
        query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject)
      };
    }
  },

  methods: {
    refetch: function refetch() {
      if (this.$apollo.queries.myTournaments) this.$apollo.queries.myTournaments.refetch();
    }
  },
  created: function created() {
    var _this = this;

    // This is a temporary way of updating the location data (refetching on local change).
    // Ideally we subscribe to location-update events and refetch then, but firebase cloud functions
    // doesn't support web sockets for graphql subscriptions.
    // An alternative is to move the api off Firebase.
    // Another alternative is to do the subscription through Firebase events.
    this.$root.$on("updateTournament", function (id) {
      _this.refetch();
    });
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_listingComponents_tournaments_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_listingComponents_tournaments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_listingComponents_tournaments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n          query {\n            publicTournaments {\n              id\n              name\n              description\n              comments\n              sport\n              circuit\n              startDate\n              endDate\n              format\n              location {\n                name\n              }\n            }\n          }\n        "], ["\n          query {\n            publicTournaments {\n              id\n              name\n              description\n              comments\n              sport\n              circuit\n              startDate\n              endDate\n              format\n              location {\n                name\n              }\n            }\n          }\n        "]);

//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "PublicTournaments",
  components: { Tournaments: __WEBPACK_IMPORTED_MODULE_1__components_listingComponents_tournaments_vue___default.a },

  apollo: {
    publicTournaments: function publicTournaments() {
      return {
        query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject)
      };
    }
  },
  methods: {
    refetch: function refetch() {
      if (this.$apollo.queries.publicTournaments) this.$apollo.queries.publicTournaments.refetch();
    }
  },
  created: function created() {
    var _this = this;

    // This is a temporary way of updating the location data (refetching on local change).
    // Ideally we subscribe to location-update events and refetch then, but firebase cloud functions
    // doesn't support web sockets for graphql subscriptions.
    // An alternative is to move the api off Firebase.
    // Another alternative is to do the subscription through Firebase events.
    this.$root.$on("updateTournament", function (id) {
      _this.refetch();
    });
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tournamentComponents_tournamentDetails__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tournamentComponents_tournamentDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tournamentComponents_tournamentDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tournamentComponents_tournamentCompetitors__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tournamentComponents_tournamentCompetitors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tournamentComponents_tournamentCompetitors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tournamentComponents_tournamentMatches__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tournamentComponents_tournamentMatches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tournamentComponents_tournamentMatches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tournamentComponents_tournamentFlights__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tournamentComponents_tournamentFlights___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tournamentComponents_tournamentFlights__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tournamentComponents_tournamentVenues__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tournamentComponents_tournamentVenues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tournamentComponents_tournamentVenues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_timers__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dialogs_generateKODrawDialog_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dialogs_generateKODrawDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_dialogs_generateKODrawDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dialogs_generateFriendlyKODrawDialog_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dialogs_generateFriendlyKODrawDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_dialogs_generateFriendlyKODrawDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_dialogs_generateRRDrawDialog_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_dialogs_generateRRDrawDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_dialogs_generateRRDrawDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_dialogs_simulatePlayDialog_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_dialogs_simulatePlayDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_dialogs_simulatePlayDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_dialogs_upsertTournamentDialog_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_dialogs_upsertTournamentDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_dialogs_upsertTournamentDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!) {\n              resetDraw(tournamentId: $tournamentId) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!) {\n              resetDraw(tournamentId: $tournamentId) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "]),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!) {\n              deleteTournament(tournamentId: $tournamentId)\n            }\n          "], ["\n            mutation($tournamentId: ID!) {\n              deleteTournament(tournamentId: $tournamentId)\n            }\n          "]),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $isPublic: Boolean!) {\n              toggleTournamentPublicity(\n                tournamentId: $tournamentId\n                isPublic: $isPublic\n              ) {\n                ...TournamentMain\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!, $isPublic: Boolean!) {\n              toggleTournamentPublicity(\n                tournamentId: $tournamentId\n                isPublic: $isPublic\n              ) {\n                ...TournamentMain\n              }\n            }\n            ", "\n          "]);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Tournament",
  components: {
    TournamentDetails: __WEBPACK_IMPORTED_MODULE_4__tournamentComponents_tournamentDetails___default.a,
    TournamentCompetitors: __WEBPACK_IMPORTED_MODULE_5__tournamentComponents_tournamentCompetitors___default.a,
    TournamentMatches: __WEBPACK_IMPORTED_MODULE_6__tournamentComponents_tournamentMatches___default.a,
    TournamentFlights: __WEBPACK_IMPORTED_MODULE_7__tournamentComponents_tournamentFlights___default.a,
    TournamentVenues: __WEBPACK_IMPORTED_MODULE_8__tournamentComponents_tournamentVenues___default.a,
    GenerateKODrawDialog: __WEBPACK_IMPORTED_MODULE_10__components_dialogs_generateKODrawDialog_vue___default.a,
    GenerateFriendlyKODrawDialog: __WEBPACK_IMPORTED_MODULE_11__components_dialogs_generateFriendlyKODrawDialog_vue___default.a,
    GenerateRRDrawDialog: __WEBPACK_IMPORTED_MODULE_12__components_dialogs_generateRRDrawDialog_vue___default.a,
    SimulatePlayDialog: __WEBPACK_IMPORTED_MODULE_13__components_dialogs_simulatePlayDialog_vue___default.a,
    UpsertTournamentDialog: __WEBPACK_IMPORTED_MODULE_14__components_dialogs_upsertTournamentDialog_vue___default.a
  },

  apollo: {
    tournament: function tournament() {
      // this query has to be a function to be called after the component is created, giving access to the other properties
      return {
        query: __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["a" /* tournamentQuery */],
        variables: function variables() {
          return {
            id: this.tournamentId
          };
        }
      };
    }
  },

  data: function data() {
    return {
      showKODialog: false,
      showFriendlyKODialog: false,
      showRRDialog: false,
      showSimulationDialog: false,
      showConfirmResetDraw: false,
      showConfirmDelete: false,
      showEditTournamentDialog: false
    };
  },

  computed: {
    currentUser: {
      get: function get() {
        return this.$store.state.currentUser;
      }
    },
    tournamentId: {
      get: function get() {
        return this.$store.getters.currentTournamentId;
      }
    },
    tournamentDates: {
      get: function get() {
        return (this.tournament.startDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_helper__["c" /* shortDate */])(this.tournament.startDate) : "???") + " - " + (this.tournament.endDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_helper__["c" /* shortDate */])(this.tournament.endDate) : "???");
      }
    }
  },

  methods: {
    truncate: __WEBPACK_IMPORTED_MODULE_3__js_helper__["d" /* truncate */],
    isMine: __WEBPACK_IMPORTED_MODULE_3__js_helper__["e" /* TournamentTools */].isMine,
    icon: __WEBPACK_IMPORTED_MODULE_3__js_helper__["e" /* TournamentTools */].icon,
    resetDraw: function resetDraw() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["b" /* tournamentMatchFragment */]),
        variables: {
          tournamentId: this.tournament.id
        }
      }).then(function (result) {
        _this.$root.$emit("updateTournament", _this.tournament.id);
        _this.$store.commit("setNotification", "Draw has been reset");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to reset draw");
      });
    },
    deleteTournament: function deleteTournament() {
      var _this2 = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2),
        variables: {
          tournamentId: this.tournament.id
        }
      }).then(function (result) {
        _this2.$store.commit("setNotification", "Tournament has been deleted");
        _this2.$router.push({ path: "/myTournaments" });
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to delete tournament");
      });
    },
    togglePublicity: function togglePublicity() {
      var _this3 = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject3, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["c" /* tournamentMainFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          isPublic: !this.tournament.isPublic
        }
      }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this3.$store.commit("setNotification", "Tournament publicity state has been changed");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to change tournament publicity state");
      });
    },
    matchesTabTitle: function matchesTabTitle(t) {
      if (t && t.matches) return "" + t.matches.length;
      return "";
    },
    competitorsTabTitle: function competitorsTabTitle(t) {
      if (t && t.competitors) return "" + t.competitors.length;
      return "";
    },
    flightsTabTitle: function flightsTabTitle(t) {
      if (t && t.flights) return "" + t.flights.length;
      return "";
    },
    refetch: function refetch() {
      if (this.$apollo.queries.tournament) this.$apollo.queries.tournament.refetch();
      //this.$store.commit("setNotification", "Tournament refetched");
    }
  },

  created: function created() {
    var _this4 = this;

    // This is a temporary way of updating the the tournament data (refetching on local change).
    // Ideally we subscribe to tournament-update events and refetch then, but firebase cloud functions
    // doesn't support web sockets for graphql subscriptions.
    // An alternative is to move the api off Firebase.
    // Another alternative is to do the subscription through Firebase events.
    this.$root.$on("updateTournament", function (id) {
      if (id === _this4.tournamentId)
        //setTimeout(() => {
        _this4.refetch();
      //}, 200);
    });
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $competitors: [CompetitorInput]!) {\n              addCompetitors(\n                tournamentId: $tournamentId\n                competitors: $competitors\n              ) {\n                ...TournamentCompetitor\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!, $competitors: [CompetitorInput]!) {\n              addCompetitors(\n                tournamentId: $tournamentId\n                competitors: $competitors\n              ) {\n                ...TournamentCompetitor\n              }\n            }\n            ", "\n          "]);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AddCompetitorsDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default.a,
  props: { tournament: Object },
  data: function data() {
    return {
      names: {
        label: "Name of competitor(s)",
        hint: "Separate names with semi-colons"
      },
      rank: {
        label: "Rank",
        value: 100,
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.names, this.rank];
      }
    },
    title: {
      get: function get() {
        return "Add competitors";
      }
    },
    instructions: {
      get: function get() {
        return "Add one or more competitors by name.";
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      var competitors = this.names.value.split(";").filter(function (x) {
        return x;
      }).map(function (x) {
        return { name: x.trim(), rank: _this.rank.value };
      });

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["g" /* tournamentCompetitorFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          competitors: competitors
          /*
          update: (_, { data: { signinPayload } }) => {
          this.$store.commit("setCurrentUser", signinPayload);
          }
          */
        } }).then(function (result) {
        _this.$root.$emit("updateTournament", _this.tournament.id);
        _this.$store.commit("setNotification", "Added competitors");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to add competitors");
      });
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_location__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__baseDialog_vue__);




var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n                mutation($locationId: ID!, $venue: VenueInput!) {\n                  upsertVenue(locationId: $locationId, venue: $venue) {\n                    ...LocationVenue\n                  }\n                }\n                ", "\n              "], ["\n                mutation($locationId: ID!, $venue: VenueInput!) {\n                  upsertVenue(locationId: $locationId, venue: $venue) {\n                    ...LocationVenue\n                  }\n                }\n                ", "\n              "]);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AddVenueDialog",
  extends: __WEBPACK_IMPORTED_MODULE_6__baseDialog_vue___default.a,
  props: { location: Object },
  data: function data() {
    return {
      names: {
        label: "Name of venue(s)"
        //hint: "Separate names with semi-colons"
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.names];
      }
    },
    title: {
      get: function get() {
        return "Add venue";
      }
    },
    instructions: {
      get: function get() {
        return "Add one or more venue by name.";
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      var venues = this.names.value.split(";").filter(function (x) {
        return x;
      }).forEach(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(name) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.$apollo.mutate({
                    mutation: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_4__graphql_location__["c" /* locationVenueFragment */]),
                    variables: {
                      locationId: _this.location.id,
                      venue: { name: name.trim() }
                    }
                  }).then(function (result) {
                    _this.$root.$emit("updateLocation", _this.location.id);
                    _this.$store.commit("setNotification", "Added venues");
                  }).catch(function (err) {
                    console.log(err);
                    window.alert("Failed to add venues");
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dialogs_modalDialog_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dialogs_modalDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_dialogs_modalDialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//



/*
 * This is a base component of a input-form dialog.
 * Extend this component and override data properties and the submit method to handle form submissions
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "BaseDialog",
  props: { show: Boolean },
  components: { ModalDialog: __WEBPACK_IMPORTED_MODULE_0__components_dialogs_modalDialog_vue___default.a },
  computed: {
    dialogInputs: {
      get: function get() {
        return [];
      }
    },
    title: {
      get: function get() {
        return "";
      }
    },
    instructions: {
      get: function get() {
        return "";
      }
    }
  },

  methods: {
    close: function close() {
      this.$emit("onClose");
    },
    submit: function submit() {
      this.title = "Oops...";
      this.instructions = "You need to extend this base component and override this the submit method";
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_baseDialog_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "BaseUpsertDialog",
  extends: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_baseDialog_vue___default.a,
  data: function data() {
    return {
      entityName: ""
    };
  },
  computed: {
    entity: {
      get: function get() {
        return null;
      }
    },
    title: {
      get: function get() {
        return (this.entity ? "Update" : "Create new") + " " + this.entityName + (this.entity && this.entity.name ? " - " + this.entity.name : "");
      }
    },
    instructions: {
      get: function get() {
        return "Please use this form to " + (this.entity ? "update the " : "create a new") + " " + this.entityName;
      }
    }
  },

  methods: {
    copyValues: function copyValues() {
      var _this = this;

      if (this.entity) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$data).forEach(function (key) {
          if (_this.entity[key]) {
            _this[key].value = _this.entity[key];
          }
        });
        this.customCopyValues();
      }
    },

    // Override this to specify custom copy operations from the entity to the input values
    customCopyValues: function customCopyValues() {}
  },
  watch: {
    entity: function entity() {
      this.copyValues();
    }
  },
  created: function created() {
    this.copyValues();
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $competitorId: ID!, $amount: Float!) {\n              updateCompetitorPayment(\n                tournamentId: $tournamentId\n                competitorId: $competitorId\n                amount: $amount\n              ) {\n                ...TournamentCompetitor\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!, $competitorId: ID!, $amount: Float!) {\n              updateCompetitorPayment(\n                tournamentId: $tournamentId\n                competitorId: $competitorId\n                amount: $amount\n              ) {\n                ...TournamentCompetitor\n              }\n            }\n            ", "\n          "]);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CompetitorPaymentDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default.a,
  props: { tournament: Object, competitor: Object },
  data: function data() {
    return {
      payment: {
        label: "Payment amount",
        value: this.competitor.amountPaid,
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.payment];
      }
    },
    title: {
      get: function get() {
        return "Payment by " + this.competitor.name;
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["g" /* tournamentCompetitorFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          competitorId: this.competitor.id,
          amount: this.payment.value
        }
      }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this.$store.commit("setNotification", "Recorded payment of " + _this.payment.value + " by " + _this.competitor.name);
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to set payment");
      });
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EditField",
  props: {
    edit: Boolean,
    input: Object
  },
  methods: {
    isCheckbox: function isCheckbox(input) {
      return this.input.type === __WEBPACK_IMPORTED_MODULE_0__js_helper__["b" /* DialogInputTypes */].bool;
    }
  },
  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.input.value = value;
        this.value = value;
      }
    }
  },
  data: function data() {
    return { value: this.input.value };
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generateKODrawDialog_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generateKODrawDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__generateKODrawDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation(\n              $tournamentId: ID!\n              $knockoutOptions: KnockoutFormatOptions!\n            ) {\n              generateFriendlyKnockoutDraw(\n                tournamentId: $tournamentId\n                knockoutOptions: $knockoutOptions\n              ) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "], ["\n            mutation(\n              $tournamentId: ID!\n              $knockoutOptions: KnockoutFormatOptions!\n            ) {\n              generateFriendlyKnockoutDraw(\n                tournamentId: $tournamentId\n                knockoutOptions: $knockoutOptions\n              ) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "]);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GenerateFriendlyKODrawDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__generateKODrawDialog_vue___default.a,
  computed: {
    title: {
      get: function get() {
        return "Generate Friendly KO Draw";
      }
    },
    instructions: {
      get: function get() {
        return "Generate a traditional binary-tree format with consolations flights similar to the 'Knockout' format except that Byes do NOT count as matches played.";
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["b" /* tournamentMatchFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          knockoutOptions: {
            numberOfConselationFlights: this.nConsolationFlights.value,
            seeds: this.nSeeds.value
          }
        }
      }).then(function (result) {
        _this.$root.$emit("updateTournament", _this.tournament.id);
        _this.$store.commit("setNotification", "Generated Friendly KO draw");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to generate Friendly KO draw");
      });
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation(\n              $tournamentId: ID!\n              $knockoutOptions: KnockoutFormatOptions!\n            ) {\n              generateKnockoutDraw(\n                tournamentId: $tournamentId\n                knockoutOptions: $knockoutOptions\n              ) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "], ["\n            mutation(\n              $tournamentId: ID!\n              $knockoutOptions: KnockoutFormatOptions!\n            ) {\n              generateKnockoutDraw(\n                tournamentId: $tournamentId\n                knockoutOptions: $knockoutOptions\n              ) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "]);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GenerateKODrawDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default.a,
  props: { tournament: Object },
  data: function data() {
    return {
      nConsolationFlights: {
        label: "Number of conselation flights",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number,
        value: 3,
        hint: "Up to 3 conselation flights are supported"
      },
      nSeeds: {
        label: "Number of seeds",
        hint: "The number of highest-ranked players to seed",
        value: 4,
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.nConsolationFlights, this.nSeeds];
      }
    },
    title: {
      get: function get() {
        return "Generate KO Draw";
      }
    },
    instructions: {
      get: function get() {
        return "Generate a traditional binary-tree format with consolations flights to potentially give competitors a second or even a third chance at winning a flight.  Byes will count as matches played.";
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["b" /* tournamentMatchFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          knockoutOptions: {
            numberOfConselationFlights: this.nConsolationFlights.value,
            seeds: this.nSeeds.value
          }
        }
      }).then(function (result) {
        _this.$root.$emit("updateTournament", _this.tournament.id);
        _this.$store.commit("setNotification", "Generated KO draw");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to generate KO draw");
      });
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generateKODrawDialog_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generateKODrawDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__generateKODrawDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation(\n              $tournamentId: ID!\n              $knockoutOptions: KnockoutFormatOptions!\n              $roundRobinOptions: RoundRobinFormatOptions!\n            ) {\n              generateRoundRobinDraw(\n                tournamentId: $tournamentId\n                knockoutOptions: $knockoutOptions\n                roundRobinOptions: $roundRobinOptions\n              ) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "], ["\n            mutation(\n              $tournamentId: ID!\n              $knockoutOptions: KnockoutFormatOptions!\n              $roundRobinOptions: RoundRobinFormatOptions!\n            ) {\n              generateRoundRobinDraw(\n                tournamentId: $tournamentId\n                knockoutOptions: $knockoutOptions\n                roundRobinOptions: $roundRobinOptions\n              ) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "]);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GenerateRRDrawDialog",
  extends: __WEBPACK_IMPORTED_MODULE_5__generateKODrawDialog_vue___default.a,
  data: function data() {
    return {
      poolSize: {
        label: "The maximum number of competitors per pool",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number,
        value: 3
      },
      competitorsPerPoolPerFlight: {
        label: "Number competitors from each pool to advance to knock rounds",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number,
        value: 1
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.poolSize, this.competitorsPerPoolPerFlight, this.nConsolationFlights, this.nSeeds];
      }
    },
    title: {
      get: function get() {
        return "Generate Round Robin Draw";
      }
    },
    instructions: {
      get: function get() {
        return "Generate a round-robin draw with pool play and knockout rounds";
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["b" /* tournamentMatchFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          knockoutOptions: {
            numberOfConselationFlights: this.nConsolationFlights.value,
            seeds: this.nSeeds.value
          },
          roundRobinOptions: {
            poolSize: this.poolSize.value,
            competitorsPerPoolPerFlight: this.competitorsPerPoolPerFlight.value
          }
        }
      }).then(function (result) {
        _this.$root.$emit("updateTournament", _this.tournament.id);
        _this.$store.commit("setNotification", "Generated Round Robin draw");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to generate Round Robin draw");
      });
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__baseDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n                mutation($name: String!, $authInput: AuthInput!) {\n                  createUser(name: $name, authInput: $authInput) {\n                    id\n                  }\n                }\n              "], ["\n                mutation($name: String!, $authInput: AuthInput!) {\n                  createUser(name: $name, authInput: $authInput) {\n                    id\n                  }\n                }\n              "]),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n              mutation($emailLogin: EmailLogin!) {\n                signinUser(emailLogin: $emailLogin) {\n                  token\n                  user {\n                    id\n                    name\n                    email\n                    maxTournaments\n                  }\n                }\n              }\n            "], ["\n              mutation($emailLogin: EmailLogin!) {\n                signinUser(emailLogin: $emailLogin) {\n                  token\n                  user {\n                    id\n                    name\n                    email\n                    maxTournaments\n                  }\n                }\n              }\n            "]);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LoginDialog",
  extends: __WEBPACK_IMPORTED_MODULE_3__baseDialog_vue___default.a,
  data: function data() {
    return {
      createAccount: false,
      name: {
        label: "Your name",
        required: true
      },
      email: {
        label: "Email",
        type: __WEBPACK_IMPORTED_MODULE_2__js_helper__["b" /* DialogInputTypes */].email,
        required: true
      },
      pw: {
        label: "Password",
        type: __WEBPACK_IMPORTED_MODULE_2__js_helper__["b" /* DialogInputTypes */].pw,
        required: true
      },
      confirmPw: {
        label: "Confirm Password",
        type: __WEBPACK_IMPORTED_MODULE_2__js_helper__["b" /* DialogInputTypes */].pw,
        required: true
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return this.createAccount ? [this.name, this.email, this.pw, this.confirmPw] : [this.email, this.pw];
      }
    },
    title: {
      get: function get() {
        return "Quick Tourney - " + (this.createAccount ? "Create account" : "Sign in");
      }
    },
    instructions: {
      get: function get() {
        return (this.createAccount ? "Create an" : "Log into your") + " account in order to manage your tournaments";
      }
    }
  },
  methods: {
    submit: function submit(results) {
      var _this = this;

      if (this.createAccount) {
        if (this.pw.value === this.confirmPw.value) return this.$apollo.mutate({
          mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
          variables: {
            name: this.name.value,
            authInput: {
              emailLogin: {
                email: this.email.value,
                password: this.pw.value
              }
            }
          }
        }).then(function (result) {
          _this.$store.commit("setNotification", "Account created, please log-in to manage your tournaments");
        }).catch(function (err) {
          window.alert("Failed to create account");
        });else window.alert("Passwords do not match");
      } else return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2),
        variables: {
          emailLogin: { email: this.email.value, password: this.pw.value }
        }
      }).then(function (result) {
        var cu = result.data.signinUser;
        _this.$store.commit("setCurrentUser", cu);
        _this.$router.push({ path: "/myTournaments" });
        _this.$store.commit("setNotification", "Welcome " + cu.user.name);
      }).catch(function (err) {
        window.alert("Login failed");
      });
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation(\n              $tournamentId: ID!\n              $matchId: ID!\n              $winnerId: ID!\n              $score: String\n            ) {\n              endMatch(\n                tournamentId: $tournamentId\n                matchId: $matchId\n                winnerId: $winnerId\n                score: $score\n              ) {\n                ...TournamentMatchEnded\n              }\n            }\n            ", "\n          "], ["\n            mutation(\n              $tournamentId: ID!\n              $matchId: ID!\n              $winnerId: ID!\n              $score: String\n            ) {\n              endMatch(\n                tournamentId: $tournamentId\n                matchId: $matchId\n                winnerId: $winnerId\n                score: $score\n              ) {\n                ...TournamentMatchEnded\n              }\n            }\n            ", "\n          "]);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MatchEndDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default.a,
  props: { tournament: Object, match: Object },
  data: function data() {
    return {
      winner: {
        label: "Winner",
        value: this.match.firstCompetitor.name,
        options: [{
          value: this.match.firstCompetitor.id,
          display: this.match.firstCompetitor.name
        }, {
          value: this.match.secondCompetitor.id,
          display: this.match.secondCompetitor.name
        }]
      },
      score: { label: "Score" },
      winnerPoints: {
        label: "Points for winner",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number,
        hint: "If points are important"
      },
      loserPoints: {
        label: "Points for loser",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number,
        hint: "If points are important"
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.winner, this.score, this.winnerPoints, this.loserPoints];
      }
    },
    title: {
      get: function get() {
        return "End match - " + this.match.name;
      }
    },
    instructions: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_3__js_helper__["g" /* MatchTools */].competitorsDescription(this.match);
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["e" /* tournamentMatchEndedFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          matchId: this.match.id,
          winnerId: this.winner.value,
          score: this.score.value,
          winnerPoints: this.winnerPoints.value,
          loserPoints: this.loserPoints.value
        }
      }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this.$store.commit("setNotification", "Match " + _this.match.name + " has been marked as ended");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to end the match");
      });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $matchId: ID!, $venueId: ID) {\n              startMatch(\n                tournamentId: $tournamentId\n                matchId: $matchId\n                venueId: $venueId\n              ) {\n                ...TournamentMatchStarted\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!, $matchId: ID!, $venueId: ID) {\n              startMatch(\n                tournamentId: $tournamentId\n                matchId: $matchId\n                venueId: $venueId\n              ) {\n                ...TournamentMatchStarted\n              }\n            }\n            ", "\n          "]);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MatchStartDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default.a,
  props: { tournament: Object, match: Object },
  data: function data() {
    return {
      venue: {
        label: "Venue for the match",
        value: __WEBPACK_IMPORTED_MODULE_3__js_helper__["h" /* NA_VENUE */]
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.venue];
      }
    },
    title: {
      get: function get() {
        return "Start match - " + this.match.name;
      }
    },
    instructions: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_3__js_helper__["g" /* MatchTools */].competitorsDescription(this.match);
      }
    }
  },
  methods: {
    copyValues: function copyValues() {
      this.venue.options = __WEBPACK_IMPORTED_MODULE_3__js_helper__["g" /* MatchTools */].venueOptions(this.tournament);
    },
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["f" /* tournamentMatchStartedFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          matchId: this.match.id,
          venueId: this.venue.value === __WEBPACK_IMPORTED_MODULE_3__js_helper__["h" /* NA_VENUE */] ? undefined : this.venue.value
          /*
          update: (_, { data: { signinPayload } }) => {
          this.$store.commit("setCurrentUser", signinPayload);
          }
          */
        } }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this.$store.commit("setNotification", "Match " + _this.match.name + " is set to start");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to start the match");
      });
    }
  },
  watch: {
    tournament: {
      handler: function handler(val) {
        this.copyValues();
      },

      deep: true
    }
  },
  created: function created() {
    this.copyValues();
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editField_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__editField_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ModelDialog",
  components: { EditField: __WEBPACK_IMPORTED_MODULE_0__editField_vue___default.a },
  props: {
    show: Boolean,
    title: String,
    instructions: String,
    dialogInputs: Array
  },
  computed: {
    isDialogVisible: {
      get: function get() {
        return this.show;
      },
      set: function set(value) {
        if (!value) this.close();
      }
    }
  },
  methods: {
    close: function close() {
      this.$emit("onClose");
    },
    submit: function submit() {
      this.$emit("onSubmit");
      this.close();
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation(\n              $tournamentId: ID!\n              $nMatches: Int\n              $probabilityOfUpsets: Float\n            ) {\n              simulatePlay(\n                tournamentId: $tournamentId\n                nMatches: $nMatches\n                probabilityOfUpsets: $probabilityOfUpsets\n              ) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "], ["\n            mutation(\n              $tournamentId: ID!\n              $nMatches: Int\n              $probabilityOfUpsets: Float\n            ) {\n              simulatePlay(\n                tournamentId: $tournamentId\n                nMatches: $nMatches\n                probabilityOfUpsets: $probabilityOfUpsets\n              ) {\n                ...TournamentMatch\n              }\n            }\n            ", "\n          "]);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SimulatePlayDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseDialog_vue___default.a,
  props: { tournament: Object },
  data: function data() {
    return {
      nMatches: {
        label: "Number of matches to simulate",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number,
        value: -1,
        hint: "To simulate all matches use -1"
      },
      probabilityOfUpsets: {
        label: "Probability of upset as a %",
        value: 0,
        hint: "A number between 0 and 1",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.nMatches, this.probabilityOfUpsets];
      }
    },
    title: {
      get: function get() {
        return "Simulate play";
      }
    },
    instructions: {
      get: function get() {
        return "Run a simulation that completes matches by choosing a winner based on the given probability of upsets.";
      }
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["b" /* tournamentMatchFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          nMatches: this.nMatches.value,
          probabilityOfUpsets: this.probabilityOfUpsets.value
        }
      }).then(function (result) {
        _this.$root.$emit("updateTournament", _this.tournament.id);
        _this.$store.commit("setNotification", "Simulation completed");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to simulate play");
      });
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $competitor: CompetitorInput!) {\n              upsertCompetitor(\n                tournamentId: $tournamentId\n                competitor: $competitor\n              ) {\n                ...TournamentCompetitor\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!, $competitor: CompetitorInput!) {\n              upsertCompetitor(\n                tournamentId: $tournamentId\n                competitor: $competitor\n              ) {\n                ...TournamentCompetitor\n              }\n            }\n            ", "\n          "]);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UpdateCompetitorDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue___default.a,
  props: { tournament: Object, competitor: Object },
  data: function data() {
    return {
      name: { label: "Name" },
      description: { label: "Description" },
      rank: { label: "Rank", type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number },
      points: { label: "Points", type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number },
      amountPaid: { label: "Amount paid", type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number },
      isActive: {
        label: "Is active",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].bool,
        hint: "Inactive competitors will not be included in new draws"
      },
      isEliminated: {
        label: "Is eliminated from competition",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].bool
      },
      results: { label: "Result sequence", disabled: true }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.name, this.description, this.rank, this.points, this.amountPaid, this.isActive, this.isEliminated, this.results];
      }
    },
    title: {
      get: function get() {
        return "Edit competitor - " + this.competitor.name;
      }
    },
    instructions: {
      get: function get() {
        return "Use this form to manual update the properties of the competitor.";
      }
    },
    entity: {
      get: function get() {
        return this.competitor;
      }
    }
  },
  methods: {
    customCopyValues: function customCopyValues() {
      this.results.value = this.competitor.resultSequence && this.competitor.resultSequence.join(", ");
    },
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["g" /* tournamentCompetitorFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          competitor: {
            id: this.competitor.id,
            name: this.name.value,
            description: this.description.value,
            rank: this.rank.value,
            points: this.points.value,
            amountPaid: this.amountPaid.value,
            isActive: this.isActive.value,
            isEliminated: this.isEliminated.value
          }
        }
      }).then(function (result) {
        _this.$root.$emit("updateTournament", _this.tournament.id);
        _this.$store.commit("setNotification", "Competitor " + _this.competitor.name + " updated");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to update the competitor");
      });
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $match: MatchInput!) {\n              updateMatch(tournamentId: $tournamentId, match: $match) {\n                ...TournamentMatchEnded\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!, $match: MatchInput!) {\n              updateMatch(tournamentId: $tournamentId, match: $match) {\n                ...TournamentMatchEnded\n              }\n            }\n            ", "\n          "]);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UpdateMatchDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue___default.a,
  props: { tournament: Object, match: Object },
  data: function data() {
    return {
      name: { label: "Name" },
      description: { label: "Description" },
      startTime: { label: "Start time", type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].datetime },
      endTime: { label: "End time", type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].datetime },
      venueId: {
        label: "Venue for the match",
        value: __WEBPACK_IMPORTED_MODULE_3__js_helper__["h" /* NA_VENUE */]
      },
      firstCompetitorId: {
        label: "First competitor"
      },
      secondCompetitorId: {
        label: "Second competitor"
      },
      winnerId: { label: "Winner" },
      loserId: { label: "Loser" },
      scoreNotes: { label: "Score" },
      winnerPoints: { label: "Winner points", type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number },
      loserPoints: { label: "Loser points", type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].number }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.name, this.description, this.venueId, this.firstCompetitorId, this.secondCompetitorId, this.winnerId, this.loserId, this.scoreNotes, this.winnerPoints, this.loserPoints];
      }
    },
    title: {
      get: function get() {
        return "Edit match - " + this.match.name;
      }
    },
    instructions: {
      get: function get() {
        return "Use this form to manual update the properties of the match.";
      }
    },
    entity: {
      get: function get() {
        return this.match;
      }
    }
  },
  methods: {
    customCopyValues: function customCopyValues() {
      var compOptions = __WEBPACK_IMPORTED_MODULE_3__js_helper__["g" /* MatchTools */].competitorOptions(this.tournament);

      this.venueId.value = this.match.venue && this.match.venue.id;
      this.venueId.options = __WEBPACK_IMPORTED_MODULE_3__js_helper__["g" /* MatchTools */].venueOptions(this.tournament);

      this.firstCompetitorId.value = this.match.firstCompetitor && this.match.firstCompetitor.id;
      this.firstCompetitorId.options = compOptions;

      this.secondCompetitorId.value = this.match.secondCompetitor && this.match.secondCompetitor.id;
      this.secondCompetitorId.options = compOptions;

      this.winnerId.value = this.match.winner && this.match.winner.id;
      this.winnerId.options = compOptions;

      this.loserId.value = this.match.loser && this.match.loser.id;
      this.loserId.options = compOptions;

      this.scoreNotes.value = this.match.score && this.match.score.notes;
      this.winnerPoints.value = this.match.score && this.match.score.totalWinnerScore;
      this.loserPoints.value = this.match.score && this.match.score.totalLoserScore;
    },
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["e" /* tournamentMatchEndedFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          match: {
            id: this.match.id,
            name: this.name.value,
            description: this.description.value,
            venueId: this.venueId.value === __WEBPACK_IMPORTED_MODULE_3__js_helper__["h" /* NA_VENUE */] ? undefined : this.venueId.value,
            firstCompetitorId: this.firstCompetitorId.value,
            secondCompetitorId: this.secondCompetitorId.value,
            winnerId: this.winnerId.value,
            loserId: this.loserId.value,
            score: {
              notes: this.scoreNotes.value,
              totalWinnerScore: this.winnerPoints.value,
              totalLoserScore: this.loserPoints.value
            }
          }
        }
      }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this.$store.commit("setNotification", "Match " + _this.match.name + " updated");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to update the match");
      });
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_location__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tinput: LocationInput!) {\n              upsertLocation(location: $tinput) {\n                ...LocationMain\n              }\n            }\n            ", "\n          "], ["\n            mutation($tinput: LocationInput!) {\n              upsertLocation(location: $tinput) {\n                ...LocationMain\n              }\n            }\n            ", "\n          "]);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UpsertLocationDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue___default.a,
  props: { location: Object },

  data: function data() {
    return {
      entityName: "location",
      name: {
        label: "Location Name",
        required: true
      },
      address: {
        label: "Address"
      },
      description: {
        label: "A Short description"
      },
      comments: {
        label: "Comments",
        multiline: true
      }
    };
  },

  computed: {
    dialogInputs: {
      get: function get() {
        return [this.name, this.address, this.description, this.comments];
      }
    },
    currentUser: {
      get: function get() {
        return this.$store.state.currentUser;
      }
    },
    entity: {
      get: function get() {
        return this.location;
      }
    }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_location__["b" /* locationMainFragment */]),
        variables: {
          tinput: {
            id: this.location && this.location.id,
            name: this.name.value,
            description: this.description.value,
            comments: this.comments.value,
            address: this.address.value,
            isActive: true
          }
        }
      }).then(function (result) {
        var x = result.data.upsertLocation;
        _this.$root.$emit("updateLocation", x.id);
        _this.$store.commit("setNotification", (_this.location ? "Updated" : "Created") + " location " + x.name);
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to update location");
      });
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n        query {\n          locations {\n            id\n            name\n          }\n        }\n      "], ["\n        query {\n          locations {\n            id\n            name\n          }\n        }\n      "]),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tinput: TournamentInput!) {\n              upsertTournament(tournament: $tinput) {\n                ...TournamentMain\n              }\n            }\n            ", "\n          "], ["\n            mutation($tinput: TournamentInput!) {\n              upsertTournament(tournament: $tinput) {\n                ...TournamentMain\n              }\n            }\n            ", "\n          "]);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UpsertTournamentDialog",
  extends: __WEBPACK_IMPORTED_MODULE_4__baseUpsertDialog_vue___default.a,
  props: { tournament: Object },

  data: function data() {
    return {
      entityName: "tournament",
      name: {
        label: "Tournament name",
        required: true
      },
      description: {
        label: "A Short description"
      },
      regulations: {
        label: "Instructions, regulations, etc,",
        multiline: true
      },
      location: {
        label: "Location of the tournament",
        options: []
      },
      circuit: {
        label: "Circuit, league, etc."
      },
      sport: {
        label: "Sport",
        options: __WEBPACK_IMPORTED_MODULE_3__js_helper__["f" /* Sports */].map(function (x) {
          return {
            value: x.name
          };
        })
      },
      startDate: {
        label: "Start date",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].datetime,
        required: true
      },
      endDate: {
        label: "End date",
        type: __WEBPACK_IMPORTED_MODULE_3__js_helper__["b" /* DialogInputTypes */].datetime,
        required: true
      }
    };
  },
  computed: {
    dialogInputs: {
      get: function get() {
        return [this.name, this.description, this.regulations, this.location, this.circuit, this.sport, this.startDate, this.endDate];
      }
    },
    currentUser: {
      get: function get() {
        return this.$store.state.currentUser;
      }
    },
    entity: {
      get: function get() {
        return this.tournament;
      }
    }
  },

  apollo: {
    locations: {
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
      result: function result(_ref) {
        var data = _ref.data,
            loading = _ref.loading,
            networkStatus = _ref.networkStatus;

        this.location.options = data.locations.map(function (x) {
          return { value: x.id, display: x.name };
        });
      },
      skip: function skip() {
        return !this.currentUser;
      }
    }
  },

  methods: {
    locationOptions: function locationOptions() {
      return this.locations.map(function (x) {
        return { value: x.id, display: x.name };
      });
    },
    submit: function submit() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["c" /* tournamentMainFragment */]),
        variables: {
          tinput: {
            id: this.tournament && this.tournament.id,
            name: this.name.value,
            description: this.description.value,
            regulations: this.regulations.value,
            locationId: this.location.value,
            circuit: this.circuit.value,
            sport: this.sport.value,
            startDate: this.startDate.value,
            endDate: this.endDate.value
          }
        }
      }).then(function (result) {
        var t = result.data.upsertTournament;
        _this.$root.$emit("updateTournament", t.id);
        _this.$store.commit("setNotification", (_this.tournament ? "Updated" : "Created") + " tournament " + t.name);
        _this.$store.commit("pushToRecentTournamentId", {
          id: t.id,
          name: t.name
        });
        _this.$router.push({ path: "/tournament" });
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to update tournament");
      });
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dialogs_upsertLocationDialog_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dialogs_upsertLocationDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_dialogs_upsertLocationDialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var toLower = function toLower(text) {
  return text.toString().toLowerCase();
};

var searchByName = function searchByName(items, term) {
  if (term) {
    return items.filter(function (item) {
      return toLower(item.name).includes(toLower(term));
    });
  }

  return items;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Locations",
  components: { UpsertLocationDialog: __WEBPACK_IMPORTED_MODULE_0__components_dialogs_upsertLocationDialog_vue___default.a },
  props: {
    title: String,
    locations: Array
  },
  data: function data() {
    return {
      showCreateLocationDialog: false,
      search: null,
      searched: []
    };
  },
  computed: {
    currentUser: {
      get: function get() {
        return this.$store.state.currentUser;
      }
    },
    emptyStateDescription: {
      get: function get() {
        var result = [];
        if (this.search) result.push("No locations matching the name '" + this.search + "'.  Try a different search term.");else result.push("There are no locations to display.");
        return result.join(" ");
      }
    }
  },
  methods: {
    searchOnTable: function searchOnTable() {
      this.searched = searchByName(this.locations, this.search);
    },
    onSelect: function onSelect(item) {
      this.$store.commit("setCurrentLocationId", item.id);
      this.$router.push({ path: "/location" });
    },
    copyEntity: function copyEntity() {
      if (this.locations) this.searched = this.locations.slice(0);
    },
    refetch: function refetch() {
      this.$root.$emit("updateLocation", null);
    }
  },
  watch: {
    locations: function locations() {
      this.copyEntity();
    }
  },
  created: function created() {
    this.copyEntity();
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_helper__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TournamentEntry",
  props: { tournament: Object },
  computed: {
    day: {
      get: function get() {
        return this.tournament.startDate ? "" + __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.tournament.startDate).format("Do") : "?";
      }
    },
    dates: {
      get: function get() {
        if (this.tournament.startDate && this.tournament.endDate && this.tournament.startDate != this.tournament.endDate) return this.formatDate(this.tournament.startDate) + " - " + this.formatDate(this.tournament.endDate);
        return this.tournament.startDate ? this.formatDate(this.tournament.startDate) : "?";
      }
    },
    details: {
      get: function get() {
        var result = [];
        result.push(this.dates);
        if (this.tournament.description) result.push(this.tournament.description);
        if (this.tournament.circuit) result.push(this.tournament.circuit);
        if (this.tournament.format) result.push(this.tournament.format);

        return result.join(", ");
      }
    },
    state: {
      get: function get() {
        var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf("day");
        var d = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.tournament.startDate).startOf("day");
        if (d < now) return "PAST";
        if (now < d) return "FUTURE";
        return "NOW";
      }
    }
  },
  methods: {
    icon: __WEBPACK_IMPORTED_MODULE_1__js_helper__["e" /* TournamentTools */].icon,
    formatDate: function formatDate(d) {
      var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(d);
      if (m.hour() === 0 && m.minute() === 0) return m.format("ddd MMM Do");
      return m.format("ddd MMM Do @ HH:mm");
    },
    onSelect: function onSelect(event) {
      this.$store.commit("pushToRecentTournamentId", {
        id: this.tournament.id,
        name: this.tournament.name
      });
      this.$router.push({ path: "/tournament" });
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tournamentEntry_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tournamentEntry_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tournamentEntry_vue__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TournamentList",
  props: { title: String, tournaments: Array, tournament: Object },
  components: { TournamentEntry: __WEBPACK_IMPORTED_MODULE_0__tournamentEntry_vue___default.a }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_upsertTournamentDialog_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_upsertTournamentDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialogs_upsertTournamentDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tournamentList_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tournamentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tournamentList_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function tournamentSorter(a, b) {
  return new Date(a.startDate) - new Date(b.startDate);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Tournaments",
  components: { UpsertTournamentDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_upsertTournamentDialog_vue___default.a, TournamentList: __WEBPACK_IMPORTED_MODULE_2__tournamentList_vue___default.a },
  props: {
    title: String,
    tournaments: Array
  },
  data: function data() {
    return {
      showCreateTournamentDialog: false
    };
  },
  computed: {
    showThisMonth: {
      get: function get() {
        return this.$store.state.showThisMonth;
      },
      set: function set(value) {
        this.$store.commit("setShowThisMonth", value);
      }
    },
    showNextMonth: {
      get: function get() {
        return this.$store.state.showNextMonth;
      },
      set: function set(value) {
        this.$store.commit("setShowNextMonth", value);
      }
    },
    showFuture: {
      get: function get() {
        return this.$store.state.showFuture;
      },
      set: function set(value) {
        this.$store.commit("setShowFuture", value);
      }
    },
    showOlder: {
      get: function get() {
        return this.$store.state.showOlder;
      },
      set: function set(value) {
        this.$store.commit("setShowOlder", value);
      }
    },

    currentUser: {
      get: function get() {
        return this.$store.state.currentUser;
      }
    },
    thisMonthTitle: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format("MMMM YYYY") + " Tournaments";
      }
    },
    nextMonthTitle: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, "M").format("MMMM YYYY") + " Tournaments";
      }
    },
    thisMonthTournaments: {
      get: function get() {
        var d = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf("month");
        return this.tournaments.filter(function (x) {
          return x.startDate && __WEBPACK_IMPORTED_MODULE_0_moment___default()(x.startDate).startOf("month").isSame(d);
        }).sort(tournamentSorter);
      }
    },
    nextMonthTournaments: {
      get: function get() {
        var d = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, "M").startOf("month");
        return this.tournaments.filter(function (x) {
          return x.startDate && __WEBPACK_IMPORTED_MODULE_0_moment___default()(x.startDate).startOf("month").isSame(d);
        }).sort(tournamentSorter);
      }
    },
    olderTournaments: {
      get: function get() {
        var d = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf("month");
        return this.tournaments.filter(function (x) {
          return x.startDate && __WEBPACK_IMPORTED_MODULE_0_moment___default()(x.startDate) < d;
        }).sort(tournamentSorter).reverse();
      }
    },
    futureTournaments: {
      get: function get() {
        var d = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, "M").endOf("month");
        return this.tournaments.filter(function (x) {
          return !x.startDate || __WEBPACK_IMPORTED_MODULE_0_moment___default()(x.startDate) > d;
        }).sort(tournamentSorter);
      }
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_competitorPaymentDialog_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_competitorPaymentDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_competitorPaymentDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_updateCompetitorDialog_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dialogs_updateCompetitorDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dialogs_updateCompetitorDialog_vue__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n              mutation(\n                $tournamentId: ID!\n                $competitorId: ID!\n                $isReady: Boolean!\n              ) {\n                toggleCompetitorReadiness(\n                  tournamentId: $tournamentId\n                  competitorId: $competitorId\n                  isReady: $isReady\n                ) {\n                  ...TournamentCompetitor\n                }\n              }\n              ", "\n            "], ["\n              mutation(\n                $tournamentId: ID!\n                $competitorId: ID!\n                $isReady: Boolean!\n              ) {\n                toggleCompetitorReadiness(\n                  tournamentId: $tournamentId\n                  competitorId: $competitorId\n                  isReady: $isReady\n                ) {\n                  ...TournamentCompetitor\n                }\n              }\n              ", "\n            "]),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $competitorId: ID!) {\n              deleteCompetitor(\n                tournamentId: $tournamentId\n                competitorId: $competitorId\n              )\n            }\n          "], ["\n            mutation($tournamentId: ID!, $competitorId: ID!) {\n              deleteCompetitor(\n                tournamentId: $tournamentId\n                competitorId: $competitorId\n              )\n            }\n          "]);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Competitor",
  components: { CompetitorPaymentDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_competitorPaymentDialog_vue___default.a, UpdateCompetitorDialog: __WEBPACK_IMPORTED_MODULE_5__components_dialogs_updateCompetitorDialog_vue___default.a },
  props: { tournament: Object, competitor: Object },
  data: function data() {
    return { showPaymentDialog: false, showEditDialog: false };
  },
  computed: {
    otherClass: {
      get: function get() {
        if (!this.competitor.isActive) return "inactive";
        if (this.competitor.isEliminated) return "eliminated";
        if (this.competitor.isReadyToCompete) return "ready";
        return "not-ready";
      }
    },
    otherInfo: {
      get: function get() {
        var info = ["Ranked " + this.competitor.rank];
        if (this.competitor.points) info.push("Points " + this.competitor.points);
        return info.join(", ");
      }
    }
  },
  methods: {
    isMine: __WEBPACK_IMPORTED_MODULE_3__js_helper__["e" /* TournamentTools */].isMine,
    makePayment: function makePayment() {
      if (this.isMine(this.tournament)) this.showPaymentDialog = true;
    },
    toggleReadiness: function toggleReadiness(isReady) {
      var _this = this;

      if (this.isMine(this.tournament)) return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_2__graphql_tournament__["g" /* tournamentCompetitorFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          competitorId: this.competitor.id,
          isReady: isReady
        }
      }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this.$store.commit("setNotification", _this.competitor.name + " is now " + (isReady ? "ready" : "NOT ready") + " to compete");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to toggle competitor readiness state");
      });
    },
    deleteCompetitor: function deleteCompetitor() {
      var _this2 = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2),
        variables: {
          tournamentId: this.tournament.id,
          competitorId: this.competitor.id
        }
      }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this2.$store.commit("setNotification", "Competitor has been removed from the tournament");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to remove competitor");
      });
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__competitor_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__competitor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__competitor_vue__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CompetitorList",
  props: { title: String, competitors: Array, tournament: Object },
  components: { Competitor: __WEBPACK_IMPORTED_MODULE_0__competitor_vue___default.a }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__match_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function getMatchSequence(winnerDestinationMatchId, nextRoundMatches) {
  if (winnerDestinationMatchId && nextRoundMatches) return nextRoundMatches.findIndex(function (x) {
    return x.id === winnerDestinationMatchId;
  });
  return -1;
}

var MATCH_EMPTY = "_";
var MATCH_CONNECTOR = "MC";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "FlightList",
  props: { flight: Object, tournament: Object },
  components: { Match: __WEBPACK_IMPORTED_MODULE_1__match_vue___default.a },
  data: function data() {
    return {
      MATCH_EMPTY: MATCH_EMPTY,
      MATCH_CONNECTOR: MATCH_CONNECTOR,
      showDiagram: true
    };
  },
  computed: {
    flightMatches: {
      get: function get() {
        var _this = this;

        return this.tournament.matches.filter(function (x) {
          return x.flightId === _this.flight.id;
        });
      }
    },
    rowOfMatches: {
      get: function get() {
        var _this2 = this;

        var n = this.flight.rounds.length;

        // Group matches into rounds and order them by winning-destination matches
        var result = [];
        var roundMatches = [];
        var nextRoundMatches = undefined;

        var _loop = function _loop(i) {
          var r = n - i - 1; // go backwards from last round to first in order determine order of matches
          var currentRound = _this2.flight.rounds[r];
          var currentRoundMatches = _this2.flightMatches.filter(function (x) {
            return x.roundId === currentRound.id;
          }).sort(function (a, b) {
            var ai = getMatchSequence(a.winnerDestinationMatchId, nextRoundMatches);
            var bi = getMatchSequence(b.winnerDestinationMatchId, nextRoundMatches);
            return ai < bi && -1 || bi < ai && 1 || 0;
          });
          nextRoundMatches = roundMatches[r] = currentRoundMatches;
        };

        for (var i = 0; i < n; i++) {
          _loop(i);
        }

        // Construct the rows for the match tables
        if (n > 1) {
          // Display as tree
          var nrows = Math.floor(Math.pow(2, n - 1) * 2);
          result = new Array(nrows);
          for (var i = 0; i < nrows; i++) {
            result[i] = [];
          } // Go through each round add the match cells and empty cells and connector cells
          for (var r = 0; r < n; r++) {
            var round = roundMatches[r];
            var skip = Math.floor(Math.pow(2, r)) - 1;
            var _i = 0;

            // Insert leading empty cells
            for (var j = 0; j < skip; j++) {
              result[j].push(MATCH_EMPTY);
              _i++;
            }

            var nmatches = round.length;
            skip = Math.floor(nrows / nmatches) - 1;
            for (var _j = 0; _j < nmatches; _j++) {
              var match = round[_j];
              result[_i].push(match);
              _i++;

              // Insert empty cells
              var nEmpty = Math.min(skip, nrows - _i);
              for (var z = 0; z < nEmpty; z++) {
                if (_j % 2 == 0 && _j < nmatches - 1) result[_i].push(MATCH_CONNECTOR);else result[_i].push(MATCH_EMPTY);
                _i += 1;
              }
            }
            // Insert trailing empty cells
            for (var _j2 = _i; _j2 < nrows; _j2++) {
              result[_i].push(MATCH_EMPTY);
            }
          }
        } else if (n > 0) {
          // Display as list
          // Construct the round robin table
          var _round = roundMatches[0];
          var _nmatches = _round.length;
          var ncomp = Math.ceil(Math.sqrt(1 + 8 * _nmatches) / 2);
          result = new Array(ncomp);
          for (var _i2 = 0; _i2 < ncomp; _i2++) {
            result[_i2] = [];
          } // Insert empty cells
          var curRow = 0;
          var accum = ncomp - 1;

          // Insert match cells
          for (var _j3 = 0; _j3 < _nmatches; _j3++) {
            if (_j3 >= accum) {
              curRow++;
              accum += ncomp - curRow - 1;
            }

            var _match = _round[_j3];
            result[curRow].push(_match);
          }
        }

        return result;
      }
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_models__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_matchStartDialog_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_matchStartDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_dialogs_matchStartDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_matchEndDialog_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dialogs_matchEndDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_dialogs_matchEndDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_updateMatchDialog_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_updateMatchDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_updateMatchDialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Match",
  props: { tournament: Object, match: Object },
  components: { MatchStartDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_matchStartDialog_vue___default.a, MatchEndDialog: __WEBPACK_IMPORTED_MODULE_3__components_dialogs_matchEndDialog_vue___default.a, UpdateMatchDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_updateMatchDialog_vue___default.a },
  data: function data() {
    return { showMatchActionDialog: false, showUpdateMatchDialog: false };
  },
  computed: {
    competitorsDescription: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].competitorsDescription(this.match);
      }
    },
    statusClass: {
      get: function get() {
        if (this.isCompleted(this.match)) return __WEBPACK_IMPORTED_MODULE_1__js_models__["a" /* MatchStatus */].Completed;
        if (this.isInProgress(this.match)) return __WEBPACK_IMPORTED_MODULE_1__js_models__["a" /* MatchStatus */].InProgress;
        if (this.isReady(this.tournament, this.match)) return __WEBPACK_IMPORTED_MODULE_1__js_models__["a" /* MatchStatus */].Ready;
        return __WEBPACK_IMPORTED_MODULE_1__js_models__["a" /* MatchStatus */].NotReady;
      }
    }
  },
  methods: {
    isMine: function isMine() {
      return __WEBPACK_IMPORTED_MODULE_0__js_helper__["e" /* TournamentTools */].isMine(this.tournament);
    },

    isReady: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].isReady,
    isInProgress: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].isInProgress,
    isCompleted: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].isCompleted,
    extraInfo: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].extraInfo,
    icon: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].icon,
    onSelect: function onSelect(event) {
      if (!this.showUpdateMatchDialog) {
        this.showMatchActionDialog = true;
      }
    },
    edit: function edit(event) {
      this.showUpdateMatchDialog = true;
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__match_vue__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MatchList",
  props: { title: String, matches: Array, tournament: Object },
  components: { Match: __WEBPACK_IMPORTED_MODULE_1__match_vue___default.a }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_tournament__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_addCompetitorsDialog_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dialogs_addCompetitorsDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dialogs_addCompetitorsDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__competitorList_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__competitorList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__competitorList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuedraggable__);



var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $orderedCompetitorIds: [ID!]!) {\n              updateRankings(\n                tournamentId: $tournamentId\n                orderedCompetitorIds: $orderedCompetitorIds\n              ) {\n                ...TournamentCompetitor\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!, $orderedCompetitorIds: [ID!]!) {\n              updateRankings(\n                tournamentId: $tournamentId\n                orderedCompetitorIds: $orderedCompetitorIds\n              ) {\n                ...TournamentCompetitor\n              }\n            }\n            ", "\n          "]);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








function nameComparer(a, b) {
  return a.name < b.name ? -1 : b.name < a.name ? 1 : rankComparer(a, b);
}
function rankComparer(a, b) {
  return a.rank < b.rank ? -1 : b.rank < a.rank ? 1 : 0;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TournamentCompetitors",
  components: { CompetitorList: __WEBPACK_IMPORTED_MODULE_5__competitorList_vue___default.a, AddCompetitorsDialog: __WEBPACK_IMPORTED_MODULE_4__components_dialogs_addCompetitorsDialog_vue___default.a, draggable: __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default.a },
  props: { tournament: Object },
  data: function data() {
    return {
      showAddCompetitorsDialog: false,
      rankings: [],
      drag: false,
      rankingsChanged: false
    };
  },
  computed: {
    rankedCompetitors: {
      get: function get() {
        if (!this.rankings || this.rankings.length === 0) this.rankings = this.tournament.competitors.filter(function (x) {
          return !x.isBye;
        }).sort(rankComparer).map(function (x, i) {
          var y = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(y, x);
          return y;
        });

        return this.rankings;
      },
      set: function set(value) {
        value.forEach(function (x, i) {
          x.rank = (i + 1) * 10;
        });
        this.rankings = value;
        this.rankingsChanged = true;
      }
    },
    dragOptions: function dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

    inactiveCompetitors: {
      get: function get() {
        return this.tournament.competitors.filter(function (x) {
          return !x.isActive && !x.isBye;
        }).sort(nameComparer);
      }
    },
    readyCompetitors: {
      get: function get() {
        return this.tournament.competitors.filter(function (x) {
          return x.isActive && !x.isBye && x.isReadyToCompete && !x.isEliminated;
        }).sort(nameComparer);
      }
    },
    eliminatedCompetitors: {
      get: function get() {
        return this.tournament.competitors.filter(function (x) {
          return x.isActive && !x.isBye && x.isEliminated;
        }).sort(nameComparer);
      }
    },
    pendingCompetitors: {
      get: function get() {
        return this.tournament.competitors.filter(function (x) {
          return x.isActive && !x.isBye && !x.isReadyToCompete && !x.isEliminated;
        }).sort(nameComparer);
      }
    }
  },
  methods: {
    isMine: __WEBPACK_IMPORTED_MODULE_6__js_helper__["e" /* TournamentTools */].isMine,
    resetRankings: function resetRankings() {
      this.rankings = [];
      this.rankingsChanged = false;
    },
    commitRankings: function commitRankings() {
      var _this = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_3__graphql_tournament__["g" /* tournamentCompetitorFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          orderedCompetitorIds: this.rankings.map(function (x) {
            return x.id;
          })
        }
      }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this.$store.commit("setNotification", "Rankings have been committed");
        _this.rankingsChanged = false;
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to commit rankings");
      });
    }
  },
  watch: {
    tournament: function tournament(t) {
      this.resetRankings();
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TournamentDetails",
  props: { tournament: Object }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flightDiagram_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flightDiagram_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flightDiagram_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TournamentFlights",
  components: {
    FlightDiagram: __WEBPACK_IMPORTED_MODULE_0__flightDiagram_vue___default.a
  },
  props: { tournament: Object },
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchList_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__matchList_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TournamentMatches",
  components: {
    MatchList: __WEBPACK_IMPORTED_MODULE_1__matchList_vue___default.a
  },
  props: { tournament: Object },
  computed: {
    showCompleted: {
      get: function get() {
        return this.$store.state.showCompleted;
      },
      set: function set(value) {
        this.$store.commit("setShowCompleted", value);
      }
    },
    showInProgress: {
      get: function get() {
        return this.$store.state.showInProgress;
      },
      set: function set(value) {
        this.$store.commit("setShowInProgress", value);
      }
    },
    showReady: {
      get: function get() {
        return this.$store.state.showReady;
      },
      set: function set(value) {
        this.$store.commit("setShowReady", value);
      }
    },
    showPending: {
      get: function get() {
        return this.$store.state.showPending;
      },
      set: function set(value) {
        this.$store.commit("setShowPending", value);
      }
    },
    completedMatches: {
      get: function get() {
        var _this = this;

        return this.tournament.matches.filter(function (x) {
          return _this.isCompleted(x);
        });
      }
    },

    inProgressMatches: {
      get: function get() {
        var _this2 = this;

        return this.tournament.matches.filter(function (x) {
          return _this2.isInProgress(x);
        });
      }
    },
    readyMatches: {
      get: function get() {
        var _this3 = this;

        return this.tournament.matches.filter(function (x) {
          return _this3.isReady(_this3.tournament, x);
        });
      }
    },
    pendingMatches: {
      get: function get() {
        var _this4 = this;

        return this.tournament.matches.filter(function (x) {
          return _this4.isPending(_this4.tournament, x);
        });
      }
    }
  },
  methods: {
    relativeTime: __WEBPACK_IMPORTED_MODULE_0__js_helper__["i" /* relativeTime */],
    isReady: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].isReady,
    isCompleted: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].isCompleted,
    isInProgress: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].isInProgress,
    isPending: __WEBPACK_IMPORTED_MODULE_0__js_helper__["g" /* MatchTools */].isPending
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_tournament__ = __webpack_require__(5);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(["\n            mutation($tournamentId: ID!, $venueIds: [ID!]!) {\n              setVenuesToUse(tournamentId: $tournamentId, venueIds: $venueIds) {\n                id\n                venuesToUse {\n                  ...TournamentVenue\n                }\n              }\n            }\n            ", "\n          "], ["\n            mutation($tournamentId: ID!, $venueIds: [ID!]!) {\n              setVenuesToUse(tournamentId: $tournamentId, venueIds: $venueIds) {\n                id\n                venuesToUse {\n                  ...TournamentVenue\n                }\n              }\n            }\n            ", "\n          "]);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TournamentVenues",
  props: { tournament: Object },
  data: function data() {
    return {
      inUse: []
    };
  },
  computed: {
    disableSave: {
      get: function get() {
        var _this = this;

        // disable saving unless the selections have changed
        if (this.tournament && this.tournament.venuesToUse) {
          if (this.inUse.length === this.tournament.venuesToUse.length) return this.tournament.venuesToUse.filter(function (x) {
            return !_this.inUse.includes(x.id);
          }).length == 0;
          return false;
        }
        return true;
      }
    }
  },
  methods: {
    isMine: __WEBPACK_IMPORTED_MODULE_2__js_helper__["e" /* TournamentTools */].isMine,
    copyVenues: function copyVenues() {
      if (this.tournament && this.tournament.venuesToUse) this.inUse = this.tournament.venuesToUse.map(function (x) {
        return x.id;
      });else this.inUse = [];
    },
    save: function save() {
      var _this2 = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, __WEBPACK_IMPORTED_MODULE_3__graphql_tournament__["d" /* tournamentVenueFragment */]),
        variables: {
          tournamentId: this.tournament.id,
          venueIds: this.inUse
        }
      }).then(function (result) {
        //this.$root.$emit("updateTournament", this.tournament.id);
        _this2.$store.commit("setNotification", "Venue configuration updated");
      }).catch(function (err) {
        console.log(err);
        window.alert("Failed to update venue configurations");
      });
    }
  },
  watch: {
    tournament: {
      handler: function handler(val) {
        this.copyVenues();
      },

      deep: true
    }
  },
  created: function created() {
    this.copyVenues();
  }
});

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 84,
	"./af.js": 84,
	"./ar": 91,
	"./ar-dz": 85,
	"./ar-dz.js": 85,
	"./ar-kw": 86,
	"./ar-kw.js": 86,
	"./ar-ly": 87,
	"./ar-ly.js": 87,
	"./ar-ma": 88,
	"./ar-ma.js": 88,
	"./ar-sa": 89,
	"./ar-sa.js": 89,
	"./ar-tn": 90,
	"./ar-tn.js": 90,
	"./ar.js": 91,
	"./az": 92,
	"./az.js": 92,
	"./be": 93,
	"./be.js": 93,
	"./bg": 94,
	"./bg.js": 94,
	"./bm": 95,
	"./bm.js": 95,
	"./bn": 96,
	"./bn.js": 96,
	"./bo": 97,
	"./bo.js": 97,
	"./br": 98,
	"./br.js": 98,
	"./bs": 99,
	"./bs.js": 99,
	"./ca": 100,
	"./ca.js": 100,
	"./cs": 101,
	"./cs.js": 101,
	"./cv": 102,
	"./cv.js": 102,
	"./cy": 103,
	"./cy.js": 103,
	"./da": 104,
	"./da.js": 104,
	"./de": 107,
	"./de-at": 105,
	"./de-at.js": 105,
	"./de-ch": 106,
	"./de-ch.js": 106,
	"./de.js": 107,
	"./dv": 108,
	"./dv.js": 108,
	"./el": 109,
	"./el.js": 109,
	"./en-au": 110,
	"./en-au.js": 110,
	"./en-ca": 111,
	"./en-ca.js": 111,
	"./en-gb": 112,
	"./en-gb.js": 112,
	"./en-ie": 113,
	"./en-ie.js": 113,
	"./en-il": 114,
	"./en-il.js": 114,
	"./en-nz": 115,
	"./en-nz.js": 115,
	"./eo": 116,
	"./eo.js": 116,
	"./es": 119,
	"./es-do": 117,
	"./es-do.js": 117,
	"./es-us": 118,
	"./es-us.js": 118,
	"./es.js": 119,
	"./et": 120,
	"./et.js": 120,
	"./eu": 121,
	"./eu.js": 121,
	"./fa": 122,
	"./fa.js": 122,
	"./fi": 123,
	"./fi.js": 123,
	"./fo": 124,
	"./fo.js": 124,
	"./fr": 127,
	"./fr-ca": 125,
	"./fr-ca.js": 125,
	"./fr-ch": 126,
	"./fr-ch.js": 126,
	"./fr.js": 127,
	"./fy": 128,
	"./fy.js": 128,
	"./gd": 129,
	"./gd.js": 129,
	"./gl": 130,
	"./gl.js": 130,
	"./gom-latn": 131,
	"./gom-latn.js": 131,
	"./gu": 132,
	"./gu.js": 132,
	"./he": 133,
	"./he.js": 133,
	"./hi": 134,
	"./hi.js": 134,
	"./hr": 135,
	"./hr.js": 135,
	"./hu": 136,
	"./hu.js": 136,
	"./hy-am": 137,
	"./hy-am.js": 137,
	"./id": 138,
	"./id.js": 138,
	"./is": 139,
	"./is.js": 139,
	"./it": 140,
	"./it.js": 140,
	"./ja": 141,
	"./ja.js": 141,
	"./jv": 142,
	"./jv.js": 142,
	"./ka": 143,
	"./ka.js": 143,
	"./kk": 144,
	"./kk.js": 144,
	"./km": 145,
	"./km.js": 145,
	"./kn": 146,
	"./kn.js": 146,
	"./ko": 147,
	"./ko.js": 147,
	"./ky": 148,
	"./ky.js": 148,
	"./lb": 149,
	"./lb.js": 149,
	"./lo": 150,
	"./lo.js": 150,
	"./lt": 151,
	"./lt.js": 151,
	"./lv": 152,
	"./lv.js": 152,
	"./me": 153,
	"./me.js": 153,
	"./mi": 154,
	"./mi.js": 154,
	"./mk": 155,
	"./mk.js": 155,
	"./ml": 156,
	"./ml.js": 156,
	"./mn": 157,
	"./mn.js": 157,
	"./mr": 158,
	"./mr.js": 158,
	"./ms": 160,
	"./ms-my": 159,
	"./ms-my.js": 159,
	"./ms.js": 160,
	"./mt": 161,
	"./mt.js": 161,
	"./my": 162,
	"./my.js": 162,
	"./nb": 163,
	"./nb.js": 163,
	"./ne": 164,
	"./ne.js": 164,
	"./nl": 166,
	"./nl-be": 165,
	"./nl-be.js": 165,
	"./nl.js": 166,
	"./nn": 167,
	"./nn.js": 167,
	"./pa-in": 168,
	"./pa-in.js": 168,
	"./pl": 169,
	"./pl.js": 169,
	"./pt": 171,
	"./pt-br": 170,
	"./pt-br.js": 170,
	"./pt.js": 171,
	"./ro": 172,
	"./ro.js": 172,
	"./ru": 173,
	"./ru.js": 173,
	"./sd": 174,
	"./sd.js": 174,
	"./se": 175,
	"./se.js": 175,
	"./si": 176,
	"./si.js": 176,
	"./sk": 177,
	"./sk.js": 177,
	"./sl": 178,
	"./sl.js": 178,
	"./sq": 179,
	"./sq.js": 179,
	"./sr": 181,
	"./sr-cyrl": 180,
	"./sr-cyrl.js": 180,
	"./sr.js": 181,
	"./ss": 182,
	"./ss.js": 182,
	"./sv": 183,
	"./sv.js": 183,
	"./sw": 184,
	"./sw.js": 184,
	"./ta": 185,
	"./ta.js": 185,
	"./te": 186,
	"./te.js": 186,
	"./tet": 187,
	"./tet.js": 187,
	"./tg": 188,
	"./tg.js": 188,
	"./th": 189,
	"./th.js": 189,
	"./tl-ph": 190,
	"./tl-ph.js": 190,
	"./tlh": 191,
	"./tlh.js": 191,
	"./tr": 192,
	"./tr.js": 192,
	"./tzl": 193,
	"./tzl.js": 193,
	"./tzm": 195,
	"./tzm-latn": 194,
	"./tzm-latn.js": 194,
	"./tzm.js": 195,
	"./ug-cn": 196,
	"./ug-cn.js": 196,
	"./uk": 197,
	"./uk.js": 197,
	"./ur": 198,
	"./ur.js": 198,
	"./uz": 200,
	"./uz-latn": 199,
	"./uz-latn.js": 199,
	"./uz.js": 200,
	"./vi": 201,
	"./vi.js": 201,
	"./x-pseudo": 202,
	"./x-pseudo.js": 202,
	"./yo": 203,
	"./yo.js": 203,
	"./zh-cn": 204,
	"./zh-cn.js": 204,
	"./zh-hk": 205,
	"./zh-hk.js": 205,
	"./zh-tw": 206,
	"./zh-tw.js": 206
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 391;

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(454),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(446),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45735a00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(457),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d2df6c6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35ac083d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(459),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9c558c80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(461),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5caa2c71",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(451),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(445),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3de46011",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(453),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7224c2fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(435),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a6c6d04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(455),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79abe478",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(447),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a582d82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(464),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e4ced90a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36829d8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(436),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f9cd2b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(437),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19478cdc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(440),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c48a0c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(434),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tournament && _vm.tournament.location) ? _c('div', [(_vm.isMine(_vm.tournament)) ? _c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": _vm.disableSave
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('md-icon', [_vm._v("save")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Save venue usage")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-list', _vm._l((_vm.tournament.location.venues), function(venue) {
    return _c('md-list-item', {
      key: venue.id
    }, [_c('md-switch', {
      attrs: {
        "value": venue.id
      },
      model: {
        value: (_vm.inUse),
        callback: function($$v) {
          _vm.inUse = $$v
        },
        expression: "inUse"
      }
    }, [_vm._v(_vm._s(venue.name) + _vm._s(venue.reservedBy && (" - " + (venue.reservedBy))))])], 1)
  }))], 1) : _c('div', [_c('p', [_vm._v("Location is not set for this tournament")])])
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    staticClass: "md-triple-line md-dense"
  }, [_c('md-subheader', [_vm._v(_vm._s(_vm.title) + " - " + _vm._s(_vm.tournaments.length))]), _vm._v(" "), _vm._l((_vm.tournaments), function(tournament) {
    return _c('md-list-item', {
      key: tournament.id
    }, [_c('TournamentEntry', {
      attrs: {
        "tournament": tournament
      }
    })], 1)
  })], 2), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMine(_vm.tournament)) ? _c('div', [_c('md-list', [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.showAddCompetitorsDialog = true
      }
    }
  }, [_c('md-icon', [_vm._v("group_add")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Add competitors")])], 1)], 1), _vm._v(" "), _c('AddCompetitorsDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showAddCompetitorsDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showAddCompetitorsDialog = false
      }
    }
  }), _vm._v(" "), _c('md-list-item', {
    staticClass: "rankings",
    attrs: {
      "md-expand": ""
    }
  }, [_c('md-icon', [_vm._v("sort")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Adjust Rankings")]), _vm._v(" "), _c('md-list', {
    staticClass: "rankings",
    attrs: {
      "slot": "md-expand"
    },
    slot: "md-expand"
  }, [_c('md-list-item', [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.resetRankings
    }
  }, [_c('md-icon', [_vm._v("cancel")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Reset rankings")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": !_vm.rankingsChanged
    },
    on: {
      "click": _vm.commitRankings
    }
  }, [_c('md-icon', [_vm._v("save")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Commit new rankings")])], 1)], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('div', [_c('p', {
    staticClass: "ranking-instructions"
  }, [_vm._v("Drag and drop the competitors in the desired ranking, stronger competitors at the top. Be sure to commit the rankings before generating the draw.")])])]), _vm._v(" "), _c('md-list-item', [_c('draggable', {
    staticClass: "list-group",
    attrs: {
      "element": "ul",
      "options": _vm.dragOptions
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.rankedCompetitors),
      callback: function($$v) {
        _vm.rankedCompetitors = $$v
      },
      expression: "rankedCompetitors"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": !_vm.drag ? 'flip-list' : null
    }
  }, _vm._l((_vm.rankedCompetitors), function(element) {
    return _c('li', {
      key: element.id,
      staticClass: "list-group-item"
    }, [_c('md-icon', [_vm._v("person")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(element.name))]), _vm._v(" "), _c('span', {
      staticClass: "rank"
    }, [_vm._v(_vm._s(element.rank))])], 1)
  }))], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tournament && _vm.tournament.competitors.length > 0) ? _c('div', [_c('div', {
    staticClass: "flex-container"
  }, [_c('CompetitorList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Not ready",
      "competitors": _vm.pendingCompetitors,
      "tournament": _vm.tournament
    }
  }), _vm._v(" "), _c('CompetitorList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Ready",
      "competitors": _vm.readyCompetitors,
      "tournament": _vm.tournament
    }
  }), _vm._v(" "), _c('CompetitorList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Eliminated",
      "competitors": _vm.eliminatedCompetitors,
      "tournament": _vm.tournament
    }
  }), _vm._v(" "), _c('CompetitorList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Inactive",
      "competitors": _vm.inactiveCompetitors,
      "tournament": _vm.tournament
    }
  })], 1)]) : _c('div', [_c('md-empty-state', {
    attrs: {
      "md-icon": "people_outline",
      "md-label": "No Competitors yet"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tournament && _vm.tournament.flights && _vm.tournament.flights.length > 0) ? _c('div', _vm._l((_vm.tournament.flights), function(flight) {
    return _c('div', {
      key: flight.id,
      staticClass: "scrollable"
    }, [_c('FlightDiagram', {
      attrs: {
        "flight": flight,
        "tournament": _vm.tournament
      }
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('p')], 1)
  })) : _c('div', [_c('md-empty-state', {
    attrs: {
      "md-icon": "remove_circle",
      "md-label": "There are currently no flights for this tournament"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    attrs: {
      "md-active": _vm.isDialogVisible
    },
    on: {
      "update:mdActive": function($event) {
        _vm.isDialogVisible = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-dialog-content', [_c('div', {
    staticClass: "sub-header"
  }, [_vm._v(_vm._s(_vm.instructions))])]), _vm._v(" "), _c('md-dialog-content', _vm._l((_vm.dialogInputs), function(input) {
    return _c('EditField', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!input.hidden),
        expression: "!input.hidden"
      }],
      key: input.label,
      attrs: {
        "edit": !input.disabled,
        "input": input
      }
    })
  })), _vm._v(" "), _c('md-dialog-content', [_vm._t("default")], 2), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tournaments) ? _c('div', [_c('md-list', {
    staticClass: "top-tools"
  }, [_c('md-toolbar', [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "md-toolbar-section-end"
  }, [(_vm.currentUser) ? _c('md-button', {
    staticClass: "md-fab md-mini md-accent",
    on: {
      "click": function($event) {
        _vm.showCreateTournamentDialog = true
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Create a new tournament")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.refetch()
      }
    }
  }, [_c('md-icon', [_vm._v("refresh")])], 1)], 1)]), _vm._v(" "), _c('md-list-item', {
    attrs: {
      "md-expand": ""
    }
  }, [_c('md-icon', [_vm._v("filter_list")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Options")]), _vm._v(" "), _c('md-list', {
    staticClass: "flex-container",
    attrs: {
      "slot": "md-expand"
    },
    slot: "md-expand"
  }, [_c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showThisMonth),
      callback: function($$v) {
        _vm.showThisMonth = $$v
      },
      expression: "showThisMonth"
    }
  }, [_vm._v("This Month")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showNextMonth),
      callback: function($$v) {
        _vm.showNextMonth = $$v
      },
      expression: "showNextMonth"
    }
  }, [_vm._v("Next Month")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showFuture),
      callback: function($$v) {
        _vm.showFuture = $$v
      },
      expression: "showFuture"
    }
  }, [_vm._v("Future")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showOlder),
      callback: function($$v) {
        _vm.showOlder = $$v
      },
      expression: "showOlder"
    }
  }, [_vm._v("Older")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [(_vm.showThisMonth) ? _c('TournamentList', {
    staticClass: "flex-item",
    attrs: {
      "title": _vm.thisMonthTitle,
      "tournaments": _vm.thisMonthTournaments
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNextMonth) ? _c('TournamentList', {
    staticClass: "flex-item",
    attrs: {
      "title": _vm.nextMonthTitle,
      "tournaments": _vm.nextMonthTournaments
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFuture) ? _c('TournamentList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Future",
      "tournaments": _vm.futureTournaments
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOlder) ? _c('TournamentList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Older",
      "tournaments": _vm.olderTournaments
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('UpsertTournamentDialog', {
    attrs: {
      "show": _vm.showCreateTournamentDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showCreateTournamentDialog = false
      }
    }
  })], 1) : _c('div', [_c('md-progress-spinner', {
    staticClass: "wait",
    attrs: {
      "md-diameter": 100,
      "md-stroke": 10,
      "md-mode": "indeterminate"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tournament && _vm.tournament.matches && _vm.tournament.matches.length > 0) ? _c('div', [_c('md-list', [_c('md-list-item', {
    attrs: {
      "md-expand": ""
    }
  }, [_c('md-icon', [_vm._v("filter_list")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Options")]), _vm._v(" "), _c('md-list', {
    staticClass: "flex-container",
    attrs: {
      "slot": "md-expand"
    },
    slot: "md-expand"
  }, [_c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showCompleted),
      callback: function($$v) {
        _vm.showCompleted = $$v
      },
      expression: "showCompleted"
    }
  }, [_vm._v("Completed matches")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showInProgress),
      callback: function($$v) {
        _vm.showInProgress = $$v
      },
      expression: "showInProgress"
    }
  }, [_vm._v("In-progress matches")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showReady),
      callback: function($$v) {
        _vm.showReady = $$v
      },
      expression: "showReady"
    }
  }, [_vm._v("Ready-to-start matches")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showPending),
      callback: function($$v) {
        _vm.showPending = $$v
      },
      expression: "showPending"
    }
  }, [_vm._v("Pending matches")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [(_vm.showCompleted) ? _c('MatchList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Completed",
      "matches": _vm.completedMatches,
      "tournament": _vm.tournament
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showInProgress) ? _c('MatchList', {
    staticClass: "flex-item",
    attrs: {
      "title": "In-progress",
      "matches": _vm.inProgressMatches,
      "tournament": _vm.tournament
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showReady) ? _c('MatchList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Ready-to-start",
      "matches": _vm.readyMatches,
      "tournament": _vm.tournament
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPending) ? _c('MatchList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Pending",
      "matches": _vm.pendingMatches,
      "tournament": _vm.tournament
    }
  }) : _vm._e()], 1)], 1) : _c('div', [_c('md-empty-state', {
    attrs: {
      "md-icon": "remove_circle",
      "md-label": "There are currently no matches for this tournament"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tournament) ? _c('div', [(_vm.tournament.regulations) ? _c('div', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Regulations")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.tournament.regulations))])]) : _vm._e(), _vm._v(" "), (_vm.tournament.commments) ? _c('div', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.tournament.comments))])]) : _vm._e()]) : _c('div', [_c('p', [_vm._v("Oops... no current tournament")])])])
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.location) ? _c('div', [_c('md-card', [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("\n            " + _vm._s(_vm.location.name) + "\n            "), _c('span', [(_vm.$apollo.loading) ? _c('md-progress-bar', {
    attrs: {
      "md-mode": "query"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('md-icon', [_vm._v("location_on")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.location.address || "unknown address"))])], 1)]), _vm._v(" "), (_vm.isMine(_vm.location)) ? _c('md-menu', {
    attrs: {
      "md-size": "big",
      "md-direction": "bottom-end"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showEditLocationDialog = true
      }
    }
  }, [_c('span', [_vm._v("Edit")]), _vm._v(" "), _c('md-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showConfirmDelete = true
      }
    }
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-card-content', [_vm._v(_vm._s(_vm.location.description))]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "md-icon-button md-primary",
    on: {
      "click": _vm.newVenue
    }
  }, [_c('md-icon', [_vm._v("add_circle")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Add Venues")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.refetch
    }
  }, [_c('md-icon', [_vm._v("refresh")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Refetch location data")])], 1)], 1)], 1), _vm._v(" "), _c('md-card-content', [_c('md-table', {
    attrs: {
      "md-fixed-header": ""
    },
    scopedSlots: _vm._u([{
      key: "md-table-row",
      fn: function(ref) {
        var item = ref.item;

        return _c('md-table-row', {
          attrs: {
            "md-selectable": "single"
          }
        }, [_c('md-table-cell', {
          attrs: {
            "md-label": "Name"
          }
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Description"
          }
        }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Reservation"
          }
        }, [_vm._v(_vm._s(item.reservedBy))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Actions"
          }
        }, [_c('md-button', {
          staticClass: "md-icon-button",
          on: {
            "click": function($event) {
              _vm.deleteVenue(item.id)
            }
          }
        }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)], 1)
      }
    }]),
    model: {
      value: (_vm.location.venues),
      callback: function($$v) {
        _vm.$set(_vm.location, "venues", $$v)
      },
      expression: "location.venues"
    }
  }, [_c('md-table-toolbar', [_c('div', {
    staticClass: "md-toolbar-section-start"
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Venues")])])]), _vm._v(" "), _c('md-table-empty-state', {
    attrs: {
      "md-label": "No venues at this location"
    }
  }, [(_vm.currentUser) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.newVenue
    }
  }, [_vm._v("Add Venues")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('AddVenueDialog', {
    attrs: {
      "location": _vm.location,
      "show": _vm.showVenueDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showVenueDialog = false
      }
    }
  }), _vm._v(" "), _c('UpsertLocationDialog', {
    attrs: {
      "show": _vm.showEditLocationDialog,
      "location": _vm.location
    },
    on: {
      "onClose": function($event) {
        _vm.showEditLocationDialog = false
      }
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.showConfirmDelete,
      "md-title": "Delete location?",
      "md-content": "Delete the location and all its venues",
      "md-confirm-text": "Confirm",
      "md-cancel-text": "Cancel"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showConfirmDelete = $event
      },
      "md-confirm": _vm.deleteLocation
    }
  })], 1) : _c('div', [_c('md-progress-spinner', {
    staticClass: "wait",
    attrs: {
      "md-diameter": 100,
      "md-stroke": 10,
      "md-mode": "indeterminate"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    staticClass: "md-triple-line md-dense"
  }, [_c('md-subheader', [_vm._v(_vm._s(_vm.title) + " matches - " + _vm._s(_vm.matches.length))]), _vm._v(" "), _vm._l((_vm.matches), function(match) {
    return _c('md-list-item', {
      key: match.id
    }, [_c('Match', {
      attrs: {
        "match": match,
        "tournament": _vm.tournament
      }
    })], 1)
  })], 2), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Tournaments', {
    attrs: {
      "title": "My Tournaments",
      "tournaments": _vm.myTournaments
    }
  })
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.locations) ? _c('div', [_c('md-table', {
    attrs: {
      "md-sort": "name",
      "md-sort-order": "asc",
      "md-card": "",
      "md-fixed-header": ""
    },
    on: {
      "md-selected": _vm.onSelect
    },
    scopedSlots: _vm._u([{
      key: "md-table-row",
      fn: function(ref) {
        var item = ref.item;

        return _c('md-table-row', {
          attrs: {
            "md-selectable": "single"
          }
        }, [_c('md-table-cell', {
          attrs: {
            "md-label": "Name",
            "md-sort-by": "name"
          }
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Address",
            "md-sort-by": "address"
          }
        }, [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Description",
            "md-sort-by": "description"
          }
        }, [_vm._v(_vm._s(item.description))])], 1)
      }
    }]),
    model: {
      value: (_vm.searched),
      callback: function($$v) {
        _vm.searched = $$v
      },
      expression: "searched"
    }
  }, [_c('md-table-toolbar', [_c('div', {
    staticClass: "md-toolbar-section-start"
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-mini md-primary",
    on: {
      "click": function($event) {
        _vm.showCreateLocationDialog = true
      }
    }
  }, [_c('md-icon', [_vm._v("add_location")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Create a new location")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.refetch()
      }
    }
  }, [_c('md-icon', [_vm._v("refresh")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Refetch location")])], 1)], 1), _vm._v(" "), _c('md-field', {
    staticClass: "md-toolbar-section-end",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('md-icon', [_vm._v("search")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Search by name..."
    },
    on: {
      "input": _vm.searchOnTable
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('md-table-empty-state', {
    attrs: {
      "md-label": "No locations found",
      "md-description": _vm.emptyStateDescription
    }
  })], 1), _vm._v(" "), _c('UpsertLocationDialog', {
    attrs: {
      "show": _vm.showCreateLocationDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showCreateLocationDialog = false
      }
    }
  })], 1) : _c('div', [_c('md-progress-spinner', {
    staticClass: "wait",
    attrs: {
      "md-diameter": 100,
      "md-stroke": 10,
      "md-mode": "indeterminate"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container",
    attrs: {
      "id": "home"
    }
  }, [_c('md-app', {
    attrs: {
      "md-mode": "fixed"
    }
  }, [_c('md-app-toolbar', {
    staticClass: "md-primary"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('md-icon', {
    staticClass: "md-size-2x",
    attrs: {
      "md-src": "/static/img/icons/logo.svg"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("Quick Tourney")]), _vm._v(" "), _c('div', {
    staticClass: "md-toolbar-section-end"
  }, [(_vm.currentUser) ? _c('div', [_c('md-button', {
    on: {
      "click": _vm.logOut
    }
  }, [_c('span', [_vm._v("Logout")]), _vm._v(" "), _c('md-icon', [_vm._v("person")])], 1)], 1) : _c('div', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.showLoginDialog = true
      }
    }
  }, [_vm._v("Login")])], 1)])], 1), _vm._v(" "), _c('md-app-drawer', {
    attrs: {
      "md-active": _vm.menuVisible
    },
    on: {
      "update:mdActive": function($event) {
        _vm.menuVisible = $event
      }
    }
  }, [_c('MainMenu')], 1), _vm._v(" "), _c('md-app-content', [_c('router-view', {
    attrs: {
      "name": "body"
    }
  })], 1)], 1), _vm._v(" "), _c('md-bottom-bar', {
    attrs: {
      "md-type": "shift",
      "md-sync-route": ""
    }
  }, [(_vm.currentUser) ? _c('md-bottom-bar-item', {
    attrs: {
      "md-label": "Mine",
      "md-icon": "domain",
      "to": "/myTournaments"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-label": "Public",
      "md-icon": "public",
      "to": "/publicTournaments"
    }
  })], 1), _vm._v(" "), _c('md-snackbar', {
    attrs: {
      "md-position": 'center',
      "md-active": _vm.showNotification,
      "md-duration": 5000,
      "md-persistent": ""
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showNotification = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.notification))])]), _vm._v(" "), _c('login-dialog', {
    attrs: {
      "show": _vm.showLoginDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showLoginDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', [_c('md-subheader', [_vm._v(_vm._s(_vm.title) + " - " + _vm._s(_vm.competitors.length))]), _vm._v(" "), _vm._l((_vm.competitors), function(competitor) {
    return _c('md-list-item', {
      key: competitor.id
    }, [_c('Competitor', {
      attrs: {
        "tournament": _vm.tournament,
        "competitor": competitor
      }
    })], 1)
  })], 2), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tournament) ? _c('div', [_c('md-card', [_c('md-card-area', {
    attrs: {
      "md-inset": ""
    }
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_c('img', {
    staticClass: "sport",
    attrs: {
      "src": _vm.icon(_vm.tournament)
    }
  }), _vm._v("\n            " + _vm._s(_vm.tournament.name) + "\n            "), _c('md-tooltip', [_vm._v(_vm._s(_vm.tournament.sport) + " - " + _vm._s(_vm.tournament.id))]), _vm._v(" "), _c('span', [(_vm.$apollo.loading) ? _c('md-progress-bar', {
    attrs: {
      "md-mode": "query"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('md-icon', [_vm._v("location_on")]), _vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.tournament.location && _vm.tournament.location.name) || "unknown location"))])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_c('md-icon', [_vm._v("date_range")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tournamentDates))])], 1)]), _vm._v(" "), (_vm.isMine(_vm.tournament)) ? _c('md-menu', {
    attrs: {
      "md-size": "auto",
      "md-direction": "bottom-end"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', [_c('span', [_vm._v("Generate draw")]), _vm._v(" "), _c('md-icon', [_vm._v("ac_unit")])], 1), _vm._v(" "), _c('md-menu-item', {
    staticClass: "md-inset md-accent",
    on: {
      "click": function($event) {
        _vm.showFriendlyKODialog = true
      }
    }
  }, [_vm._v("Friendly Knockout")]), _vm._v(" "), _c('md-menu-item', {
    staticClass: "md-inset",
    on: {
      "click": function($event) {
        _vm.showKODialog = true
      }
    }
  }, [_vm._v("Knockout")]), _vm._v(" "), _c('md-menu-item', {
    staticClass: "md-inset",
    on: {
      "click": function($event) {
        _vm.showRRDialog = true
      }
    }
  }, [_vm._v("Round Robin")]), _vm._v(" "), _c('md-divider', {
    staticClass: "md-inset"
  }), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showConfirmResetDraw = true
      }
    }
  }, [_c('span', [_vm._v("Reset draw")]), _vm._v(" "), _c('md-icon', [_vm._v("redo")])], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showSimulationDialog = true
      }
    }
  }, [_c('span', [_vm._v("Simulate play")]), _vm._v(" "), _c('md-icon', [_vm._v("compare_arrows")])], 1), _vm._v(" "), (_vm.tournament.isPublic) ? _c('md-menu-item', {
    on: {
      "click": _vm.togglePublicity
    }
  }, [_c('span', [_vm._v("Make private")]), _vm._v(" "), _c('md-icon', [_vm._v("vpn_lock")])], 1) : _c('md-menu-item', {
    on: {
      "click": _vm.togglePublicity
    }
  }, [_c('span', [_vm._v("Make public")]), _vm._v(" "), _c('md-icon', [_vm._v("public")])], 1), _vm._v(" "), _c('md-divider', {
    staticClass: "md-inset"
  }), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showEditTournamentDialog = true
      }
    }
  }, [_c('span', [_vm._v("Edit")]), _vm._v(" "), _c('md-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showConfirmDelete = true
      }
    }
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-card-content', [_vm._v(_vm._s(_vm.tournament.description))]), _vm._v(" "), _c('md-card-actions', [(_vm.tournament.format) ? _c('md-chip', [_c('md-icon', [_vm._v("ac_unit")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.truncate(_vm.tournament.format, 8)))]), _vm._v(" "), _c('md-tooltip', [_vm._v("Tournament format - " + _vm._s(_vm.tournament.format))])], 1) : _vm._e(), _vm._v(" "), (_vm.tournament.isPublic) ? _c('md-chip', {
    staticClass: "md-primary"
  }, [_c('md-icon', [_vm._v("public")]), _vm._v(" "), _c('span', [_vm._v("Public")]), _vm._v(" "), _c('md-tooltip', [_vm._v("This tournament is visible to the public")])], 1) : _c('md-chip', {
    staticClass: "md-accent"
  }, [_c('md-icon', [_vm._v("vpn_lock")]), _vm._v(" "), _c('span', [_vm._v("Private")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Only you can see this tournament")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.refetch
    }
  }, [_c('md-icon', [_vm._v("refresh")])], 1)], 1)], 1), _vm._v(" "), _c('md-card-content', [_c('md-tabs', [_c('md-tab', {
    attrs: {
      "id": "tab-matches",
      "md-label": _vm.matchesTabTitle(_vm.tournament),
      "md-icon": "play_circle_outline"
    }
  }, [_c('TournamentMatches', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-diagram",
      "md-icon": "playlist_play",
      "md-label": _vm.flightsTabTitle(_vm.tournament)
    }
  }, [_c('TournamentFlights', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-competitors",
      "md-label": _vm.competitorsTabTitle(_vm.tournament),
      "md-icon": "people"
    }
  }, [_c('TournamentCompetitors', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-details",
      "md-icon": "details"
    }
  }, [_c('TournamentDetails', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1), _vm._v(" "), (_vm.isMine(_vm.tournament)) ? _c('md-tab', {
    attrs: {
      "id": "tab-venues",
      "md-icon": "gps_fixed"
    }
  }, [_c('TournamentVenues', {
    attrs: {
      "tournament": _vm.tournament
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('GenerateKODrawDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showKODialog
    },
    on: {
      "onClose": function($event) {
        _vm.showKODialog = false
      }
    }
  }), _vm._v(" "), _c('GenerateFriendlyKODrawDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showFriendlyKODialog
    },
    on: {
      "onClose": function($event) {
        _vm.showFriendlyKODialog = false
      }
    }
  }), _vm._v(" "), _c('GenerateRRDrawDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showRRDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showRRDialog = false
      }
    }
  }), _vm._v(" "), _c('SimulatePlayDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "show": _vm.showSimulationDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showSimulationDialog = false
      }
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.showConfirmResetDraw,
      "md-title": "Reset draw?",
      "md-content": "Resetting the draw will delete all matches from the tournament... forever!",
      "md-confirm-text": "Confirm",
      "md-cancel-text": "Cancel"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showConfirmResetDraw = $event
      },
      "md-confirm": _vm.resetDraw
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    attrs: {
      "md-active": _vm.showConfirmDelete,
      "md-title": "Delete tournament?",
      "md-content": "Delete the tournament and all its matches and competitors forever!",
      "md-confirm-text": "Confirm",
      "md-cancel-text": "Cancel"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.showConfirmDelete = $event
      },
      "md-confirm": _vm.deleteTournament
    }
  }), _vm._v(" "), _c('UpsertTournamentDialog', {
    attrs: {
      "show": _vm.showEditTournamentDialog,
      "tournament": _vm.tournament
    },
    on: {
      "onClose": function($event) {
        _vm.showEditTournamentDialog = false
      }
    }
  })], 1) : _c('div', [_c('md-progress-spinner', {
    staticClass: "wait",
    attrs: {
      "md-diameter": 100,
      "md-stroke": 10,
      "md-mode": "indeterminate"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-dialog', {
    attrs: {
      "show": _vm.show,
      "title": _vm.title,
      "instructions": _vm.instructions,
      "dialogInputs": _vm.dialogInputs
    },
    on: {
      "click": _vm.close,
      "onClose": _vm.close,
      "onSubmit": function($event) {
        _vm.submit()
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-dialog', {
    attrs: {
      "show": _vm.show,
      "title": _vm.title,
      "instructions": _vm.instructions,
      "dialogInputs": _vm.dialogInputs
    },
    on: {
      "click": _vm.close,
      "onClose": _vm.close,
      "onSubmit": function($event) {
        _vm.submit()
      }
    }
  }, [(_vm.createAccount) ? _c('div', [_c('div', [_vm._v("Already have an account?")]), _vm._v(" "), _c('md-button', {
    on: {
      "click": function($event) {
        _vm.createAccount = false
      }
    }
  }, [_vm._v("Log in instead")])], 1) : _c('div', [_c('div', [_vm._v("Don't have an account?")]), _vm._v(" "), _c('md-button', {
    on: {
      "click": function($event) {
        _vm.createAccount = true
      }
    }
  }, [_vm._v("Create one for free!")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isCheckbox(_vm.input)) ? _c('div', [_c('md-checkbox', {
    attrs: {
      "disabled": !_vm.edit
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, [_vm._v(_vm._s(_vm.input.label))]), _vm._v(" "), _c('span', {
    staticClass: "md-helper-text"
  }, [_vm._v(_vm._s(_vm.input.hint))])], 1) : _c('div', [_c('md-field', [_c('label', [_vm._v(_vm._s(_vm.input.label))]), _vm._v(" "), (_vm.input.options) ? _c('md-select', {
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.input.options), function(item) {
    return _c('md-option', {
      key: item.value,
      attrs: {
        "disabled": !_vm.edit,
        "required": _vm.input.required,
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.display || item.value))])
  })) : (_vm.input.multiline) ? _c('md-textarea', {
    staticClass: "md-primary",
    attrs: {
      "disabled": !_vm.edit,
      "required": _vm.input.required
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }) : _c('md-input', {
    staticClass: "md-primary",
    attrs: {
      "disabled": !_vm.edit,
      "required": _vm.input.required,
      "type": _vm.input.type
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-helper-text"
  }, [_vm._v(_vm._s(_vm.input.hint))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    class: "md-triple-line md-dense "
  }, [_c('md-list-item', {
    class: ("tournament " + _vm.state),
    on: {
      "click": _vm.onSelect
    }
  }, [_c('div', {
    staticClass: "tournament-day"
  }, [_vm._v(_vm._s(_vm.day))]), _vm._v(" "), _c('div', {
    staticClass: "md-list-item-text"
  }, [_c('span', {
    staticClass: "tournament-name"
  }, [_vm._v(_vm._s(_vm.tournament.name))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.dates))])]), _vm._v(" "), (_vm.tournament.location) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.tournament.location.name))])]) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "sport",
    attrs: {
      "src": _vm.icon(_vm.tournament)
    }
  })]), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.details))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Oops... unable to initate account linking")])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    class: ("md-double-line md-dense competitor " + _vm.otherClass)
  }, [_c('md-list-item', [(_vm.isMine(_vm.tournament)) ? _c('md-menu', {
    attrs: {
      "md-size": "big",
      "md-direction": "bottom-start"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [(!_vm.competitor.isActive) ? _c('md-icon', [_vm._v("not_interested")]) : (_vm.competitor.isEliminated) ? _c('md-icon', [_vm._v("sentiment_dissatisfied")]) : (_vm.competitor.isReadyToCompete) ? _c('md-icon', [_vm._v("how_to_reg")]) : _c('md-icon', [_vm._v("person_outline")])], 1), _vm._v(" "), _c('md-menu-content', [(_vm.competitor.isReadyToCompete) ? _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.toggleReadiness(false)
      }
    }
  }, [_c('span', [_vm._v("Set status to NOT-ready")]), _vm._v(" "), _c('md-icon', [_vm._v("person_outline")])], 1) : (!_vm.competitor.isEliminated) ? _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.toggleReadiness(true)
      }
    }
  }, [_c('span', [_vm._v("Set status to READY")]), _vm._v(" "), _c('md-icon', [_vm._v("how_to_reg")])], 1) : _vm._e(), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.showEditDialog = true
      }
    }
  }, [_c('span', [_vm._v("Edit")]), _vm._v(" "), _c('md-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": function($event) {
        _vm.deleteCompetitor()
      }
    }
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "md-list-item-text"
  }, [_c('span', {
    staticClass: "competitor-name"
  }, [_vm._v(_vm._s(_vm.competitor.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.otherInfo))]), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.competitor.name) + " - " + _vm._s(_vm.otherInfo))])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.makePayment
    }
  }, [(_vm.competitor.amountPaid) ? _c('span', [_vm._v("$" + _vm._s(_vm.competitor.amountPaid))]) : _c('md-icon', [_vm._v("attach_money")])], 1)], 1)], 1), _vm._v(" "), _c('CompetitorPaymentDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "competitor": _vm.competitor,
      "show": _vm.showPaymentDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showPaymentDialog = false
      }
    }
  }), _vm._v(" "), _c('UpdateCompetitorDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "competitor": _vm.competitor,
      "show": _vm.showEditDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showEditDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Locations', {
    attrs: {
      "title": "My Locations",
      "locations": _vm.locations
    }
  })
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Info', {
    attrs: {
      "title": "Contact Information"
    }
  }, [_c('article', [_c('p', [_vm._v("\n      Please contact us via\n      "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/Quick-Tourney-406848122730934/"
    }
  }, [_vm._v("our facebook page.")])]), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://www.facebook.com/Quick-Tourney-406848122730934/",
      "data-layout": "standard",
      "data-action": "like",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://www.facebook.com/Quick-Tourney-406848122730934/",
      "data-layout": "standard",
      "data-action": "recommend",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "true"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    class: ("md-triple-line md-dense match-info-list match " + _vm.statusClass)
  }, [_c('md-list-item', {
    on: {
      "click": _vm.onSelect
    }
  }, [_c('div', {
    staticClass: "match-name"
  }, [_vm._v(_vm._s(_vm.match.name))]), _vm._v(" "), _c('div', {
    staticClass: "md-list-item-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.match.description))]), _vm._v(" "), _c('span', {
    staticClass: "match-competitors"
  }, [_vm._v(_vm._s(_vm.competitorsDescription))]), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.competitorsDescription) + " - " + _vm._s(_vm.match.description) + " - " + _vm._s(_vm.extraInfo(_vm.tournament, _vm.match)))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.extraInfo(_vm.tournament, _vm.match)))])])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.edit
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.icon(_vm.tournament, _vm.match)))])], 1)], 1)], 1), _vm._v(" "), (_vm.isMine()) ? _c('div', [(_vm.isReady(_vm.tournament, _vm.match)) ? _c('MatchStartDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "match": _vm.match,
      "show": _vm.showMatchActionDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showMatchActionDialog = false
      }
    }
  }) : (_vm.isInProgress(_vm.match)) ? _c('MatchEndDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "match": _vm.match,
      "show": _vm.showMatchActionDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showMatchActionDialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('UpdateMatchDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "match": _vm.match,
      "show": _vm.showUpdateMatchDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showUpdateMatchDialog = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-toolbar', {
    staticClass: "md-transparent",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Quick Tourney")]), _vm._v(" "), _c('md-icon', {
    staticClass: "md-size-2x",
    attrs: {
      "md-src": "/static/img/icons/logo.svg"
    }
  })], 1), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('md-list', [_c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/publicTournaments')
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("public")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Public Tournaments")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "section-header"
  }, [_c('md-icon', [_vm._v("favorite")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Recent Tournaments")])], 1), _vm._v(" "), _vm._l((_vm.favourites), function(x) {
    return _c('md-list-item', {
      key: x.id,
      staticClass: "md-inset",
      on: {
        "click": function($event) {
          _vm.selectTournament(x)
        }
      }
    }, [_c('span', {
      staticClass: "md-list-item-text recent"
    }, [_vm._v(_vm._s(x.name))])])
  }), _vm._v(" "), (_vm.currentUser) ? _c('div', [_c('md-list-item', {
    staticClass: "section-header"
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v(_vm._s(_vm.currentUser.user.name))])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.showCreateTournamentDialog = true
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-accent"
  }, [_vm._v("add_circle")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Create Tournament")])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/myTournaments')
      }
    }
  }, [_c('md-icon', [_vm._v("domain")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("My Tournaments")])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/myLocations')
      }
    }
  }, [_c('md-icon', [_vm._v("location_on")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("My Locations")])], 1), _vm._v(" "), _c('md-divider')], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/help')
      }
    }
  }, [_c('md-icon', [_vm._v("help")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Help")])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/contact')
      }
    }
  }, [_c('md-icon', [_vm._v("message")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Contact Us")])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/about')
      }
    }
  }, [_c('md-icon', [_vm._v("info")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("About")])], 1)], 2), _vm._v(" "), _c('UpsertTournamentDialog', {
    attrs: {
      "show": _vm.showCreateTournamentDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showCreateTournamentDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Tournaments', {
    attrs: {
      "title": "Public Tournaments",
      "tournaments": _vm.publicTournaments
    }
  })
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Info', {
    attrs: {
      "title": "About Quick Tourney"
    }
  }, [_c('article', [_c('p', [_vm._v("This site is designed to provide FREE tournament management facilities to the general public. The target audience includes:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Club tournament directors")]), _vm._v(" "), _c('li', [_vm._v("Anyone who wants to generate draws and quickly run a tournament")]), _vm._v(" "), _c('li', [_vm._v("Competitors who like to keep track of tournament status in real-time")])]), _vm._v(" "), _c('p', [_vm._v("\n      Unlike other tournament-management tools, this site allows you to easily add/remove/change/re-rank competitors and regenerate draws automatically.\n      You will see match statuses such as in-progress, ready-to-begin, pending, and completed. You can also see who has been eliminated.\n      The site is designed to record the starting and ending of matches with as few clicks and/or keystrokes as possible.\n    ")]), _vm._v(" "), _c('p', [_vm._v("Although the draw-formats that are currently supported are tailored to tennis and badminton tournaments; you can use your imagination on applying them to other sports.")]), _vm._v(" "), _c('p', [_vm._v("\n      Please note that all tournaments are editable/managable only by their creators and the webmaster; however, all tournaments details on this site are viewable in read-only mode to the general public\n      if you specifically make the tournament PUBLIC.\n      Tournament details include competitor information and match results.\n      The idea is to allow competitors and spectators to see the progress of a tournament in real-time.\n    ")])]), _vm._v(" "), _c('aside', [_c('h2', [_vm._v("Disclaimer")]), _vm._v(" "), _c('p', [_vm._v("\n      We will not use the information that is stored on this site for any commercial gain. We do not make any guarantees as to the functionality of the website.\n      We do not guarantee that the data stored on this site will persist for any amount of time. Please use at your own risk.\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Info', {
    attrs: {
      "title": "Help"
    }
  }, [_c('details', {
    staticClass: "level1"
  }, [_c('summary', {
    staticClass: "level1"
  }, [_vm._v("Create and Run a Tournament")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n        The simple tournament takes place at some location and consists of a list of competitors and a draw-format.\n        The draw-format determines how matches are made and whether and how competitors advance after their matches.\n        To create a tournament:\n      ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Create a new location. This step is optional.")]), _vm._v(" "), _c('li', [_vm._v("\n          Create a new tournament and give it a name and select a location. Then select/view the tournament.\n          You may choose to make your tournament visible to the public so that competitors and fans can follow the progression of your tournament.\n        ")]), _vm._v(" "), _c('li', [_vm._v("Add competitors to the tournament and rank them.")]), _vm._v(" "), _c('li', [_vm._v("Optionally add and remove venues for the tournament.")]), _vm._v(" "), _c('li', [_vm._v("\n          Generate the draw by picking a Draw Format (see below for format details).\n          The draw will consist of a list of matches that are organized into flights, rounds, pools, etc. depending on the draw format.\n        ")]), _vm._v(" "), _c('li', [_vm._v("Optionally record competitor arrivals and payment statuses (if applicable)")]), _vm._v(" "), _c('li', [_vm._v("Start matches that are ready to begin.")]), _vm._v(" "), _c('li', [_vm._v("End matches that are in progress.")])])])]), _vm._v(" "), _c('details', {
    staticClass: "level1"
  }, [_c('summary', {
    staticClass: "level1"
  }, [_vm._v("Tournament/Draw Formats")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n        This is the interesting stuff; all the other fluff is just cosmetic and supporting infrastructure.\n        The algorithms for generating draws may seem trivial but it can get pretty neat.\n        Trying to find the fairest way to construct draws that also provide for the best competition is fun and this is primarily what motivated the original project.\n        We don't claim that any of the supported draw-formats are new to the world but implementing them in our own style is entertaining.\n      ")]), _vm._v(" "), _c('details', {
    staticClass: "level2"
  }, [_c('summary', {
    staticClass: "level2"
  }, [_vm._v("Knockout")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("This is the traditional binary-tree format with consolations flights to potentially give competitors a second or even a third chance at winning a flight.")]), _vm._v(" "), _c('p', [_vm._v("\n            All competitors start in the top (A) flight. Each flight has a number of rounds depending on the number of competitors.\n            There are an adjustable number of consolation flights where match losers progress to.\n            Matches are organized so that, if rankings are representative of actual skill, subsequent matches become more competitive; ie. \"best against worst\" scenerios in the intial stage of each flight.\n            Hence, if rankings are representative, flights should naturally evolve to include competitors of comparable skill levels.\n            Other features of this format include:\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Zero consolation flights generates a single-flight draw, single elimination tournament.")]), _vm._v(" "), _c('li', [_vm._v("\n              One consolation flights generates an A-B-type, 2 match guarantee tournament.\n              First-round losers in flight A progress to the first round of flight B.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Two consolation flights generates an A-B-C-type, 2 match guarantee tournament.\n              First-round losers in flight A progress to the first round of flight C;\n              second-round losers of flight A progress to flight B.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              A maximum of three consolation flights produces an A-B-C-D-type draw.\n              First-round losers in flight A progress to the first round of flight C;\n              second-round losers of flight A progress to flight B;\n              first-round losers of flight C progress to flight D.\n            ")]), _vm._v(" "), _c('li', [_vm._v("A Bye counts as a match.")]), _vm._v(" "), _c('li', [_vm._v("Rankings do not factor into how consolation are constructed since all flights are generated concurrently.")])])])]), _vm._v(" "), _c('details', {
    staticClass: "level2"
  }, [_c('summary', {
    staticClass: "level2"
  }, [_vm._v("Friendly Knockout")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n            This format is similar to the 'Knockout' format except that Byes do NOT count as matches played.\n            This change means that the algorithm tries MUCH harder to guarantee a certain number of matches played for each competitor.\n            This might sunds simple but it is not. This small discrepancy can dramatically change how the draw is generated.\n            For example, consolation flights cannot be generated until all competitors have *played* a certain number of matches; again, byes do not count as matches played.\n            Other features of this format include:\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Rankings are factored into how consolation flights are constructed.")]), _vm._v(" "), _c('li', [_vm._v("Defaults and withdraws may cause violation to the \"number of matches-played guaranteed\" feature.")]), _vm._v(" "), _c('li', [_vm._v("\n              The first round of flight A is arranged with an algorithm that is contrary to the best-agains-worst method, in order to avoid the \"sacraficially lamb\" scenerio:\n              When 'D' competitors are forced to play eachother in the first round while all the other higher-ranked competitors get byes,\n              leading to some 'D' competitors continuing on to the second round of flight A where they are slaughted by higher-ranked competitors;\n              furthermore, they then drop down to flight B where they will likely be out-matched again and get eliminated by a 'B' level competitor.\n              As you can image this scenerio would not be fun for any player/team involved. Ideally, if the rankings are accurate, competitors should stay or drop to a flight that groups competitors of similar skill level.\n            ")])]), _vm._v("Anomalies include:\n          "), _c('ul', [_c('li', [_vm._v("Under circumstances that include a certain number of byes and lots of upsets, a flight (likely flight B) will not have enough players/teams to create even one match.")]), _vm._v(" "), _c('li', [_vm._v("It is possible for competitors to play eachother a second time in flight B.")])])])]), _vm._v(" "), _c('details', {
    staticClass: "level2"
  }, [_c('summary', {
    staticClass: "level2"
  }, [_vm._v("Round Robin")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("A round-robin format is ideal when you have a small number of competitors and you want to guarantee everyone a certain number of matches that would not be possible in a straight knock-out format.")]), _vm._v(" "), _c('p', [_vm._v("\n            Competitors are placed in pools using a ping-pong distribution algorithm.\n            Competitors in a pool play eachother once to determine the pool standings.\n            When all the round-robin matches are completed then a specified number of knock-out flights are generated.\n            The number of competitors-per-pool-per-flight parameter (N) specifies how many competitors from each pool will go to a flight.\n            The top N competitors from each pool advances to flight A; the next N competitors from each pool advances to flight B, etc.\n            Competitors who do not advance to any flight are eliminated from the tournament.\n            The knock-out flights are single-elimination.\n          ")])])]), _vm._v(" "), _c('details', {
    staticClass: "level2"
  }, [_c('summary', {
    staticClass: "level2"
  }, [_vm._v("Other Formats")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("We're working on it.")])])])])]), _vm._v(" "), _c('details', {
    staticClass: "level1"
  }, [_c('summary', {
    staticClass: "level1"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('div', [_c('p'), _vm._v(" "), _c('details', {
    staticClass: "level2"
  }, [_c('summary', {
    staticClass: "level2"
  }, [_vm._v("Are there limitations on the number of tournaments, location, competitors and venues I can create?")]), _vm._v(" "), _c('p', [_vm._v("\n          Yes, by default all users have a limit of 5 tournaments and 5 locations.\n          Each tournament can have a maximum of 256 competitors and each location can have a maximum of 32 venues.\n          These limitations can be adjusted on an individual basis depending on the circumstances. Please contact us if you need your limits adjusted.\n          These limiations are necessary to prevent abuse of the system and to keep our costs down; we operate the site on coffee and a very limited budget.\n          Please consider becoming a sponsor or making a donation to help keep the site running. Thanks.\n        ")])]), _vm._v(" "), _c('details', {
    staticClass: "level2"
  }, [_c('summary', {
    staticClass: "level2"
  }, [_vm._v("Can competitors register for my tournament themselves, online?")]), _vm._v(" "), _c('p', [_vm._v("\n          This feature is currently not supported.\n          Since we are targeting tournament organizers of small clubs and organizations this feature is not a high priority for us and it may take some convincing to change our minds.\n          Tournament organizers are responsible for adding competitors, ranking them and collecting their payments (if any).\n          This site allows you to record competitor payments but we do not handle any monetary transactions.\n        ")])]), _vm._v(" "), _c('details', {
    staticClass: "level2"
  }, [_c('summary', {
    staticClass: "level2"
  }, [_vm._v("Why can't people see/find my tournament?")]), _vm._v(" "), _c('p', [_vm._v("You need to make your tournament public by pressing the, um, \"Make Tournament PUBLIC\" action in the tournament view.")])]), _vm._v(" "), _c('details', {
    staticClass: "level2"
  }, [_c('summary', {
    staticClass: "level2"
  }, [_vm._v("How does this site make money?")]), _vm._v(" "), _c('p', [_vm._v("It doesn't. We created this to run our own tournaments, but it doesn't cost much to let others use it too.")])])])])])
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.flight.name))]), _vm._v(" "), _c('md-switch', {
    model: {
      value: (_vm.showDiagram),
      callback: function($$v) {
        _vm.showDiagram = $$v
      },
      expression: "showDiagram"
    }
  }, [_c('div', {
    staticClass: "sub-header"
  }, [_vm._v(_vm._s(((_vm.flightMatches.length) + " matches")))])]), _vm._v(" "), _c('p'), _vm._v(" "), (_vm.showDiagram) ? _c('table', {
    staticClass: "flight"
  }, _vm._l((_vm.rowOfMatches), function(row) {
    return _c('tr', _vm._l((row), function(match) {
      return _c('td', {
        key: match.id,
        class: match === _vm.MATCH_EMPTY ? 'empty' : match === _vm.MATCH_CONNECTOR ? 'match-connector' : 'match'
      }, [(match.id) ? _c('Match', {
        attrs: {
          "match": match,
          "tournament": _vm.tournament
        }
      }) : _vm._e()], 1)
    }))
  })) : _vm._e(), _vm._v(" "), (_vm.flight.rounds.length < 2 && _vm.flight.standings && _vm.flight.standings.length > 0) ? _c('div', [_c('p'), _vm._v(" "), _c('md-table', {
    attrs: {
      "md-card": ""
    },
    model: {
      value: (_vm.flight.standings),
      callback: function($$v) {
        _vm.$set(_vm.flight, "standings", $$v)
      },
      expression: "flight.standings"
    }
  }, [_c('md-table-toolbar', [_c('h3', [_vm._v(_vm._s(_vm.flight.name) + " Standings")])]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-numeric": ""
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('md-table-head', [_vm._v("Name")]), _vm._v(" "), _c('md-table-head', [_vm._v("Results")]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-numeric": ""
    }
  }, [_vm._v("Points")]), _vm._v(" "), _vm._l((_vm.flight.standings), function(item, index) {
    return _c('md-table-row', {
      key: item.id
    }, [_c('md-table-cell', {
      attrs: {
        "md-numeric": ""
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.resultSequence && item.resultSequence.join("·")))]), _vm._v(" "), _c('md-table-cell', {
      attrs: {
        "md-numeric": ""
      }
    }, [_vm._v(_vm._s(item.points))])], 1)
  })], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Oops... should not be here!")])
},staticRenderFns: []}

/***/ })
],[254]);


// WEBPACK FOOTER //
// static/js/app.1e242c2ac339f0383681.js